/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/

import * as thrift from "thrift";
import { Int64 } from "thrift";
import * as PAppNotifications from "./../../notification/messages";
import * as PContact from "./.";
export enum TAppPersona {
    PERSONAL = 0,
    PROFESSIONAL = 1
}
export enum TAppProvenance {
    UNDEFINED = 57,
    MOUSE = 1,
    HELIOS = 12,
    SUNSHINE = 71,
    IPHONE = 0,
    GOOGLE_PROFILE = 32,
    GOOGLE_CONTACTS = 6,
    GOOGLE_CONTACTS_OTHER = 29,
    GOOGLE_DIRECTORY = 30,
    GOOGLE_CALENDAR = 63,
    APPLE_CALENDAR = 64,
    FACEBOOK_BIRTHDAY = 62,
    GMAIL_EMAIL_CORRESPONDENCE = 27,
    LINKEDIN_GMAIL = 35,
    EMAIL_HTML_SIG = 20,
    EMAIL_PLAINTEXT_SIG = 21,
    MANUAL_MERGE = 38,
    MERGE = 39,
    LCM = 68,
    SHARE = 7,
    ACCEPTED_LCM = 13,
    REJECTED_LCM = 66,
    ACCEPTED_NAME_SUGGESTION = 11,
    UNARCHIVE_SUGGESTION = 67,
    CARD_DAV = 9,
    PUBLIC_LINKEDIN = 51,
    COMPANY_DOMAIN = 14,
    WHITEPAGES = 60,
    TWILIO = 56,
    GOOGLE_PLACES = 31,
    IS_THIS_YOU = 61,
    PUBLIC_FACEBOOK = 24,
    CONSOLE = 3,
    NAME_GMAIL = 46,
    NAME_FROM_EMAIL_USERNAME = 41,
    NAME_FROM_LINKEDIN_URL = 42,
    UNTRUSTED_GMAIL_HEADER = 58,
    UNTRUSTED_WHITEPAGES_NAME = 59,
    NAME_FROM_SIGNATURE_BODY = 43,
    NAME_FROM_SIGNATURE_HEADER = 45,
    NAME_FROM_SIGNATURE_BODY_HEURISTICS = 44,
    CONTEXT_FROM_NAME = 15,
    NAME_FROM_PROF_INFO = 65,
    NAME_GENERATED_FROM_CANONICAL = 25,
    CONTACT_URL = 72,
    POSTABLE = 73
}
export enum TAppExportAction {
    NO_OP = 0,
    UPSERT = 1,
    DELETE = 2
}
export enum TAppBirthdayPreference {
    NONE = 0,
    MESSAGE = 1,
    FLOWERS = 2,
    GIFT = 3
}
export enum TAppThirdPartyIdSource {
    UNDEFINED = 0,
    FACEBOOK = 1,
    LINKEDIN = 2,
    TWITTER = 3,
    INSTAGRAM = 4,
    VENMO = 5,
    URL = 6,
    FACEBOOK_MESSENGER = 7,
    WHATSAPP = 8,
    SNAPCHAT = 9,
    YELP = 10
}
export enum TAppContactType {
    UNDEFINED = 0,
    PERSON = 1,
    BUSINESS = 2
}
export const APP_PROVENANCE_TO_DISPLAY_STRING_MAP: Map<TAppProvenance, string> = new Map([[TAppProvenance.ACCEPTED_LCM, "Your Phone"], [TAppProvenance.ACCEPTED_NAME_SUGGESTION, "Your Phone"], [TAppProvenance.APPLE_CALENDAR, "Your calendar"], [TAppProvenance.CARD_DAV, "Your Phone"], [TAppProvenance.COMPANY_DOMAIN, "Public Internet"], [TAppProvenance.CONSOLE, "Sunshine Inferred"], [TAppProvenance.CONTEXT_FROM_NAME, "Sunshine Inferred"], [TAppProvenance.EMAIL_HTML_SIG, "Gmail"], [TAppProvenance.EMAIL_PLAINTEXT_SIG, "Gmail"], [TAppProvenance.FACEBOOK_BIRTHDAY, "Facebook"], [TAppProvenance.PUBLIC_FACEBOOK, "Public Internet"], [TAppProvenance.GMAIL_EMAIL_CORRESPONDENCE, "Gmail"], [TAppProvenance.GOOGLE_CALENDAR, "Google Calendar"], [TAppProvenance.GOOGLE_CONTACTS, "Google Contacts"], [TAppProvenance.GOOGLE_CONTACTS_OTHER, "Google Contacts"], [TAppProvenance.GOOGLE_DIRECTORY, "Google Contacts"], [TAppProvenance.GOOGLE_PLACES, "Public Internet"], [TAppProvenance.GOOGLE_PROFILE, "Google Profile"], [TAppProvenance.HELIOS, "Your Phone"], [TAppProvenance.IPHONE, "Your Phone"], [TAppProvenance.LCM, "Sunshine Inferred"], [TAppProvenance.LINKEDIN_GMAIL, "Gmail"], [TAppProvenance.MANUAL_MERGE, "Sunshine Inferred"], [TAppProvenance.MERGE, "Sunshine Inferred"], [TAppProvenance.MOUSE, "Your Phone"], [TAppProvenance.NAME_FROM_EMAIL_USERNAME, "Sunshine Inferred"], [TAppProvenance.NAME_FROM_LINKEDIN_URL, "Public Internet"], [TAppProvenance.NAME_FROM_PROF_INFO, "Sunshine Inferred"], [TAppProvenance.NAME_FROM_SIGNATURE_BODY, "Gmail"], [TAppProvenance.NAME_FROM_SIGNATURE_BODY_HEURISTICS, "Gmail"], [TAppProvenance.NAME_FROM_SIGNATURE_HEADER, "Gmail"], [TAppProvenance.NAME_GENERATED_FROM_CANONICAL, "Sunshine Inferred"], [TAppProvenance.NAME_GMAIL, "Gmail"], [TAppProvenance.PUBLIC_LINKEDIN, "Public Internet"], [TAppProvenance.REJECTED_LCM, "Your Phone"], [TAppProvenance.SHARE, "Shared With You"], [TAppProvenance.TWILIO, "Public Internet"], [TAppProvenance.UNARCHIVE_SUGGESTION, "Your Phone"], [TAppProvenance.UNTRUSTED_GMAIL_HEADER, "Gmail"], [TAppProvenance.UNTRUSTED_WHITEPAGES_NAME, "Public Internet"], [TAppProvenance.WHITEPAGES, "Public Internet"], [TAppProvenance.IS_THIS_YOU, "Sunshine Inferred"], [TAppProvenance.UNDEFINED, "Unknown"], [TAppProvenance.SUNSHINE, "Sunshine"], [TAppProvenance.CONTACT_URL, "Shared With You"], [TAppProvenance.POSTABLE, "Postable"]]);
export interface ITAppNameArgs {
    fullName?: string;
    prefix?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    suffix?: string;
    addressedAs?: string;
    nameAliases?: Set<string>;
    _provenance?: TAppProvenance;
    improved?: boolean;
    provenances?: Set<TAppProvenance>;
    provenanceDescriptors?: Set<string>;
}
export class TAppName {
    public fullName?: string;
    public prefix?: string;
    public firstName?: string;
    public middleName?: string;
    public lastName?: string;
    public suffix?: string;
    public addressedAs?: string;
    public nameAliases?: Set<string>;
    public _provenance?: TAppProvenance;
    public improved?: boolean;
    public provenances?: Set<TAppProvenance>;
    public provenanceDescriptors?: Set<string>;
    constructor(args?: ITAppNameArgs) {
        if (args != null && args.fullName != null) {
            this.fullName = args.fullName;
        }
        if (args != null && args.prefix != null) {
            this.prefix = args.prefix;
        }
        if (args != null && args.firstName != null) {
            this.firstName = args.firstName;
        }
        if (args != null && args.middleName != null) {
            this.middleName = args.middleName;
        }
        if (args != null && args.lastName != null) {
            this.lastName = args.lastName;
        }
        if (args != null && args.suffix != null) {
            this.suffix = args.suffix;
        }
        if (args != null && args.addressedAs != null) {
            this.addressedAs = args.addressedAs;
        }
        if (args != null && args.nameAliases != null) {
            this.nameAliases = args.nameAliases;
        }
        if (args != null && args._provenance != null) {
            this._provenance = args._provenance;
        }
        if (args != null && args.improved != null) {
            this.improved = args.improved;
        }
        if (args != null && args.provenances != null) {
            this.provenances = args.provenances;
        }
        if (args != null && args.provenanceDescriptors != null) {
            this.provenanceDescriptors = args.provenanceDescriptors;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppName");
        if (this.fullName != null) {
            output.writeFieldBegin("fullName", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.fullName);
            output.writeFieldEnd();
        }
        if (this.prefix != null) {
            output.writeFieldBegin("prefix", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.prefix);
            output.writeFieldEnd();
        }
        if (this.firstName != null) {
            output.writeFieldBegin("firstName", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.firstName);
            output.writeFieldEnd();
        }
        if (this.middleName != null) {
            output.writeFieldBegin("middleName", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.middleName);
            output.writeFieldEnd();
        }
        if (this.lastName != null) {
            output.writeFieldBegin("lastName", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.lastName);
            output.writeFieldEnd();
        }
        if (this.suffix != null) {
            output.writeFieldBegin("suffix", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.suffix);
            output.writeFieldEnd();
        }
        if (this.addressedAs != null) {
            output.writeFieldBegin("addressedAs", thrift.Thrift.Type.STRING, 7);
            output.writeString(this.addressedAs);
            output.writeFieldEnd();
        }
        if (this.nameAliases != null) {
            output.writeFieldBegin("nameAliases", thrift.Thrift.Type.SET, 8);
            output.writeSetBegin(thrift.Thrift.Type.STRING, this.nameAliases.size);
            this.nameAliases.forEach((value_1: string): void => {
                output.writeString(value_1);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        if (this._provenance != null) {
            output.writeFieldBegin("_provenance", thrift.Thrift.Type.I32, 9);
            output.writeI32(this._provenance);
            output.writeFieldEnd();
        }
        if (this.improved != null) {
            output.writeFieldBegin("improved", thrift.Thrift.Type.BOOL, 10);
            output.writeBool(this.improved);
            output.writeFieldEnd();
        }
        if (this.provenances != null) {
            output.writeFieldBegin("provenances", thrift.Thrift.Type.SET, 11);
            output.writeSetBegin(thrift.Thrift.Type.I32, this.provenances.size);
            this.provenances.forEach((value_2: TAppProvenance): void => {
                output.writeI32(value_2);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        if (this.provenanceDescriptors != null) {
            output.writeFieldBegin("provenanceDescriptors", thrift.Thrift.Type.SET, 12);
            output.writeSetBegin(thrift.Thrift.Type.STRING, this.provenanceDescriptors.size);
            this.provenanceDescriptors.forEach((value_3: string): void => {
                output.writeString(value_3);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppName {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_4: string = input.readString();
                        _args.fullName = value_4;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_5: string = input.readString();
                        _args.prefix = value_5;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_6: string = input.readString();
                        _args.firstName = value_6;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_7: string = input.readString();
                        _args.middleName = value_7;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_8: string = input.readString();
                        _args.lastName = value_8;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_9: string = input.readString();
                        _args.suffix = value_9;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_10: string = input.readString();
                        _args.addressedAs = value_10;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_11: Set<string> = new Set<string>();
                        const metadata_1: thrift.TSet = input.readSetBegin();
                        const size_1: number = metadata_1.size;
                        for (let i_1: number = 0; i_1 < size_1; i_1++) {
                            const value_12: string = input.readString();
                            value_11.add(value_12);
                        }
                        input.readSetEnd();
                        _args.nameAliases = value_11;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_13: TAppProvenance = input.readI32();
                        _args._provenance = value_13;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_14: boolean = input.readBool();
                        _args.improved = value_14;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_15: Set<TAppProvenance> = new Set<TAppProvenance>();
                        const metadata_2: thrift.TSet = input.readSetBegin();
                        const size_2: number = metadata_2.size;
                        for (let i_2: number = 0; i_2 < size_2; i_2++) {
                            const value_16: TAppProvenance = input.readI32();
                            value_15.add(value_16);
                        }
                        input.readSetEnd();
                        _args.provenances = value_15;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_17: Set<string> = new Set<string>();
                        const metadata_3: thrift.TSet = input.readSetBegin();
                        const size_3: number = metadata_3.size;
                        for (let i_3: number = 0; i_3 < size_3; i_3++) {
                            const value_18: string = input.readString();
                            value_17.add(value_18);
                        }
                        input.readSetEnd();
                        _args.provenanceDescriptors = value_17;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppName(_args);
    }
}
export interface ITAppPhoneArgs {
    phoneNumber?: string;
    displayNumber?: string;
    label?: string;
    likelyMobile?: boolean;
    isInactive?: boolean;
    skipExport?: boolean;
    improved?: boolean;
    provenances?: Set<TAppProvenance>;
    provenanceDescriptors?: Set<string>;
}
export class TAppPhone {
    public phoneNumber?: string;
    public displayNumber?: string;
    public label?: string;
    public likelyMobile?: boolean;
    public isInactive?: boolean;
    public skipExport?: boolean;
    public improved?: boolean;
    public provenances?: Set<TAppProvenance>;
    public provenanceDescriptors?: Set<string>;
    constructor(args?: ITAppPhoneArgs) {
        if (args != null && args.phoneNumber != null) {
            this.phoneNumber = args.phoneNumber;
        }
        if (args != null && args.displayNumber != null) {
            this.displayNumber = args.displayNumber;
        }
        if (args != null && args.label != null) {
            this.label = args.label;
        }
        if (args != null && args.likelyMobile != null) {
            this.likelyMobile = args.likelyMobile;
        }
        if (args != null && args.isInactive != null) {
            this.isInactive = args.isInactive;
        }
        if (args != null && args.skipExport != null) {
            this.skipExport = args.skipExport;
        }
        if (args != null && args.improved != null) {
            this.improved = args.improved;
        }
        if (args != null && args.provenances != null) {
            this.provenances = args.provenances;
        }
        if (args != null && args.provenanceDescriptors != null) {
            this.provenanceDescriptors = args.provenanceDescriptors;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhone");
        if (this.phoneNumber != null) {
            output.writeFieldBegin("phoneNumber", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.phoneNumber);
            output.writeFieldEnd();
        }
        if (this.displayNumber != null) {
            output.writeFieldBegin("displayNumber", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.displayNumber);
            output.writeFieldEnd();
        }
        if (this.label != null) {
            output.writeFieldBegin("label", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.label);
            output.writeFieldEnd();
        }
        if (this.likelyMobile != null) {
            output.writeFieldBegin("likelyMobile", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.likelyMobile);
            output.writeFieldEnd();
        }
        if (this.isInactive != null) {
            output.writeFieldBegin("isInactive", thrift.Thrift.Type.BOOL, 6);
            output.writeBool(this.isInactive);
            output.writeFieldEnd();
        }
        if (this.skipExport != null) {
            output.writeFieldBegin("skipExport", thrift.Thrift.Type.BOOL, 7);
            output.writeBool(this.skipExport);
            output.writeFieldEnd();
        }
        if (this.improved != null) {
            output.writeFieldBegin("improved", thrift.Thrift.Type.BOOL, 9);
            output.writeBool(this.improved);
            output.writeFieldEnd();
        }
        if (this.provenances != null) {
            output.writeFieldBegin("provenances", thrift.Thrift.Type.SET, 10);
            output.writeSetBegin(thrift.Thrift.Type.I32, this.provenances.size);
            this.provenances.forEach((value_19: TAppProvenance): void => {
                output.writeI32(value_19);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        if (this.provenanceDescriptors != null) {
            output.writeFieldBegin("provenanceDescriptors", thrift.Thrift.Type.SET, 11);
            output.writeSetBegin(thrift.Thrift.Type.STRING, this.provenanceDescriptors.size);
            this.provenanceDescriptors.forEach((value_20: string): void => {
                output.writeString(value_20);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhone {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_21: string = input.readString();
                        _args.phoneNumber = value_21;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_22: string = input.readString();
                        _args.displayNumber = value_22;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_23: string = input.readString();
                        _args.label = value_23;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_24: boolean = input.readBool();
                        _args.likelyMobile = value_24;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_25: boolean = input.readBool();
                        _args.isInactive = value_25;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_26: boolean = input.readBool();
                        _args.skipExport = value_26;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_27: boolean = input.readBool();
                        _args.improved = value_27;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_28: Set<TAppProvenance> = new Set<TAppProvenance>();
                        const metadata_4: thrift.TSet = input.readSetBegin();
                        const size_4: number = metadata_4.size;
                        for (let i_4: number = 0; i_4 < size_4; i_4++) {
                            const value_29: TAppProvenance = input.readI32();
                            value_28.add(value_29);
                        }
                        input.readSetEnd();
                        _args.provenances = value_28;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_30: Set<string> = new Set<string>();
                        const metadata_5: thrift.TSet = input.readSetBegin();
                        const size_5: number = metadata_5.size;
                        for (let i_5: number = 0; i_5 < size_5; i_5++) {
                            const value_31: string = input.readString();
                            value_30.add(value_31);
                        }
                        input.readSetEnd();
                        _args.provenanceDescriptors = value_30;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppPhone(_args);
    }
}
export interface ITAppEmailArgs {
    emailAddress?: string;
    displayEmail?: string;
    label?: string;
    isInactive?: boolean;
    skipExport?: boolean;
    improved?: boolean;
    provenances?: Set<TAppProvenance>;
    provenanceDescriptors?: Set<string>;
}
export class TAppEmail {
    public emailAddress?: string;
    public displayEmail?: string;
    public label?: string;
    public isInactive?: boolean;
    public skipExport?: boolean;
    public improved?: boolean;
    public provenances?: Set<TAppProvenance>;
    public provenanceDescriptors?: Set<string>;
    constructor(args?: ITAppEmailArgs) {
        if (args != null && args.emailAddress != null) {
            this.emailAddress = args.emailAddress;
        }
        if (args != null && args.displayEmail != null) {
            this.displayEmail = args.displayEmail;
        }
        if (args != null && args.label != null) {
            this.label = args.label;
        }
        if (args != null && args.isInactive != null) {
            this.isInactive = args.isInactive;
        }
        if (args != null && args.skipExport != null) {
            this.skipExport = args.skipExport;
        }
        if (args != null && args.improved != null) {
            this.improved = args.improved;
        }
        if (args != null && args.provenances != null) {
            this.provenances = args.provenances;
        }
        if (args != null && args.provenanceDescriptors != null) {
            this.provenanceDescriptors = args.provenanceDescriptors;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEmail");
        if (this.emailAddress != null) {
            output.writeFieldBegin("emailAddress", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.emailAddress);
            output.writeFieldEnd();
        }
        if (this.displayEmail != null) {
            output.writeFieldBegin("displayEmail", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.displayEmail);
            output.writeFieldEnd();
        }
        if (this.label != null) {
            output.writeFieldBegin("label", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.label);
            output.writeFieldEnd();
        }
        if (this.isInactive != null) {
            output.writeFieldBegin("isInactive", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.isInactive);
            output.writeFieldEnd();
        }
        if (this.skipExport != null) {
            output.writeFieldBegin("skipExport", thrift.Thrift.Type.BOOL, 6);
            output.writeBool(this.skipExport);
            output.writeFieldEnd();
        }
        if (this.improved != null) {
            output.writeFieldBegin("improved", thrift.Thrift.Type.BOOL, 8);
            output.writeBool(this.improved);
            output.writeFieldEnd();
        }
        if (this.provenances != null) {
            output.writeFieldBegin("provenances", thrift.Thrift.Type.SET, 9);
            output.writeSetBegin(thrift.Thrift.Type.I32, this.provenances.size);
            this.provenances.forEach((value_32: TAppProvenance): void => {
                output.writeI32(value_32);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        if (this.provenanceDescriptors != null) {
            output.writeFieldBegin("provenanceDescriptors", thrift.Thrift.Type.SET, 10);
            output.writeSetBegin(thrift.Thrift.Type.STRING, this.provenanceDescriptors.size);
            this.provenanceDescriptors.forEach((value_33: string): void => {
                output.writeString(value_33);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEmail {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_34: string = input.readString();
                        _args.emailAddress = value_34;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_35: string = input.readString();
                        _args.displayEmail = value_35;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_36: string = input.readString();
                        _args.label = value_36;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_37: boolean = input.readBool();
                        _args.isInactive = value_37;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_38: boolean = input.readBool();
                        _args.skipExport = value_38;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_39: boolean = input.readBool();
                        _args.improved = value_39;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_40: Set<TAppProvenance> = new Set<TAppProvenance>();
                        const metadata_6: thrift.TSet = input.readSetBegin();
                        const size_6: number = metadata_6.size;
                        for (let i_6: number = 0; i_6 < size_6; i_6++) {
                            const value_41: TAppProvenance = input.readI32();
                            value_40.add(value_41);
                        }
                        input.readSetEnd();
                        _args.provenances = value_40;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_42: Set<string> = new Set<string>();
                        const metadata_7: thrift.TSet = input.readSetBegin();
                        const size_7: number = metadata_7.size;
                        for (let i_7: number = 0; i_7 < size_7; i_7++) {
                            const value_43: string = input.readString();
                            value_42.add(value_43);
                        }
                        input.readSetEnd();
                        _args.provenanceDescriptors = value_42;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppEmail(_args);
    }
}
export interface ITAppAddressArgs {
    address1?: string;
    address2?: string;
    city?: string;
    admin1?: string;
    postalCode?: string;
    country?: string;
    label?: string;
    isInactive?: boolean;
    skipExport?: boolean;
    improved?: boolean;
    provenances?: Set<TAppProvenance>;
    provenanceDescriptors?: Set<string>;
}
export class TAppAddress {
    public address1?: string;
    public address2?: string;
    public city?: string;
    public admin1?: string;
    public postalCode?: string;
    public country?: string;
    public label?: string;
    public isInactive?: boolean;
    public skipExport?: boolean;
    public improved?: boolean;
    public provenances?: Set<TAppProvenance>;
    public provenanceDescriptors?: Set<string>;
    constructor(args?: ITAppAddressArgs) {
        if (args != null && args.address1 != null) {
            this.address1 = args.address1;
        }
        if (args != null && args.address2 != null) {
            this.address2 = args.address2;
        }
        if (args != null && args.city != null) {
            this.city = args.city;
        }
        if (args != null && args.admin1 != null) {
            this.admin1 = args.admin1;
        }
        if (args != null && args.postalCode != null) {
            this.postalCode = args.postalCode;
        }
        if (args != null && args.country != null) {
            this.country = args.country;
        }
        if (args != null && args.label != null) {
            this.label = args.label;
        }
        if (args != null && args.isInactive != null) {
            this.isInactive = args.isInactive;
        }
        if (args != null && args.skipExport != null) {
            this.skipExport = args.skipExport;
        }
        if (args != null && args.improved != null) {
            this.improved = args.improved;
        }
        if (args != null && args.provenances != null) {
            this.provenances = args.provenances;
        }
        if (args != null && args.provenanceDescriptors != null) {
            this.provenanceDescriptors = args.provenanceDescriptors;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppAddress");
        if (this.address1 != null) {
            output.writeFieldBegin("address1", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.address1);
            output.writeFieldEnd();
        }
        if (this.address2 != null) {
            output.writeFieldBegin("address2", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.address2);
            output.writeFieldEnd();
        }
        if (this.city != null) {
            output.writeFieldBegin("city", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.city);
            output.writeFieldEnd();
        }
        if (this.admin1 != null) {
            output.writeFieldBegin("admin1", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.admin1);
            output.writeFieldEnd();
        }
        if (this.postalCode != null) {
            output.writeFieldBegin("postalCode", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.postalCode);
            output.writeFieldEnd();
        }
        if (this.country != null) {
            output.writeFieldBegin("country", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.country);
            output.writeFieldEnd();
        }
        if (this.label != null) {
            output.writeFieldBegin("label", thrift.Thrift.Type.STRING, 7);
            output.writeString(this.label);
            output.writeFieldEnd();
        }
        if (this.isInactive != null) {
            output.writeFieldBegin("isInactive", thrift.Thrift.Type.BOOL, 9);
            output.writeBool(this.isInactive);
            output.writeFieldEnd();
        }
        if (this.skipExport != null) {
            output.writeFieldBegin("skipExport", thrift.Thrift.Type.BOOL, 10);
            output.writeBool(this.skipExport);
            output.writeFieldEnd();
        }
        if (this.improved != null) {
            output.writeFieldBegin("improved", thrift.Thrift.Type.BOOL, 12);
            output.writeBool(this.improved);
            output.writeFieldEnd();
        }
        if (this.provenances != null) {
            output.writeFieldBegin("provenances", thrift.Thrift.Type.SET, 13);
            output.writeSetBegin(thrift.Thrift.Type.I32, this.provenances.size);
            this.provenances.forEach((value_44: TAppProvenance): void => {
                output.writeI32(value_44);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        if (this.provenanceDescriptors != null) {
            output.writeFieldBegin("provenanceDescriptors", thrift.Thrift.Type.SET, 14);
            output.writeSetBegin(thrift.Thrift.Type.STRING, this.provenanceDescriptors.size);
            this.provenanceDescriptors.forEach((value_45: string): void => {
                output.writeString(value_45);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppAddress {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_46: string = input.readString();
                        _args.address1 = value_46;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_47: string = input.readString();
                        _args.address2 = value_47;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_48: string = input.readString();
                        _args.city = value_48;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_49: string = input.readString();
                        _args.admin1 = value_49;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_50: string = input.readString();
                        _args.postalCode = value_50;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_51: string = input.readString();
                        _args.country = value_51;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_52: string = input.readString();
                        _args.label = value_52;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_53: boolean = input.readBool();
                        _args.isInactive = value_53;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_54: boolean = input.readBool();
                        _args.skipExport = value_54;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_55: boolean = input.readBool();
                        _args.improved = value_55;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 13:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_56: Set<TAppProvenance> = new Set<TAppProvenance>();
                        const metadata_8: thrift.TSet = input.readSetBegin();
                        const size_8: number = metadata_8.size;
                        for (let i_8: number = 0; i_8 < size_8; i_8++) {
                            const value_57: TAppProvenance = input.readI32();
                            value_56.add(value_57);
                        }
                        input.readSetEnd();
                        _args.provenances = value_56;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 14:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_58: Set<string> = new Set<string>();
                        const metadata_9: thrift.TSet = input.readSetBegin();
                        const size_9: number = metadata_9.size;
                        for (let i_9: number = 0; i_9 < size_9; i_9++) {
                            const value_59: string = input.readString();
                            value_58.add(value_59);
                        }
                        input.readSetEnd();
                        _args.provenanceDescriptors = value_58;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppAddress(_args);
    }
}
export interface ITAppDateArgs {
    year?: string;
    month?: string;
    day?: string;
    improved?: boolean;
    provenances?: Set<TAppProvenance>;
    provenanceDescriptors?: Set<string>;
}
export class TAppDate {
    public year?: string;
    public month?: string;
    public day?: string;
    public improved?: boolean;
    public provenances?: Set<TAppProvenance>;
    public provenanceDescriptors?: Set<string>;
    constructor(args?: ITAppDateArgs) {
        if (args != null && args.year != null) {
            this.year = args.year;
        }
        if (args != null && args.month != null) {
            this.month = args.month;
        }
        if (args != null && args.day != null) {
            this.day = args.day;
        }
        if (args != null && args.improved != null) {
            this.improved = args.improved;
        }
        if (args != null && args.provenances != null) {
            this.provenances = args.provenances;
        }
        if (args != null && args.provenanceDescriptors != null) {
            this.provenanceDescriptors = args.provenanceDescriptors;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppDate");
        if (this.year != null) {
            output.writeFieldBegin("year", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.year);
            output.writeFieldEnd();
        }
        if (this.month != null) {
            output.writeFieldBegin("month", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.month);
            output.writeFieldEnd();
        }
        if (this.day != null) {
            output.writeFieldBegin("day", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.day);
            output.writeFieldEnd();
        }
        if (this.improved != null) {
            output.writeFieldBegin("improved", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.improved);
            output.writeFieldEnd();
        }
        if (this.provenances != null) {
            output.writeFieldBegin("provenances", thrift.Thrift.Type.SET, 6);
            output.writeSetBegin(thrift.Thrift.Type.I32, this.provenances.size);
            this.provenances.forEach((value_60: TAppProvenance): void => {
                output.writeI32(value_60);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        if (this.provenanceDescriptors != null) {
            output.writeFieldBegin("provenanceDescriptors", thrift.Thrift.Type.SET, 7);
            output.writeSetBegin(thrift.Thrift.Type.STRING, this.provenanceDescriptors.size);
            this.provenanceDescriptors.forEach((value_61: string): void => {
                output.writeString(value_61);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppDate {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_62: string = input.readString();
                        _args.year = value_62;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_63: string = input.readString();
                        _args.month = value_63;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_64: string = input.readString();
                        _args.day = value_64;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_65: boolean = input.readBool();
                        _args.improved = value_65;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_66: Set<TAppProvenance> = new Set<TAppProvenance>();
                        const metadata_10: thrift.TSet = input.readSetBegin();
                        const size_10: number = metadata_10.size;
                        for (let i_10: number = 0; i_10 < size_10; i_10++) {
                            const value_67: TAppProvenance = input.readI32();
                            value_66.add(value_67);
                        }
                        input.readSetEnd();
                        _args.provenances = value_66;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_68: Set<string> = new Set<string>();
                        const metadata_11: thrift.TSet = input.readSetBegin();
                        const size_11: number = metadata_11.size;
                        for (let i_11: number = 0; i_11 < size_11; i_11++) {
                            const value_69: string = input.readString();
                            value_68.add(value_69);
                        }
                        input.readSetEnd();
                        _args.provenanceDescriptors = value_68;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppDate(_args);
    }
}
export interface ITAppProfessionalInfoArgs {
    jobTitle?: string;
    departmentName?: string;
    companyName?: string;
    startDate?: TAppDate;
    endDate?: TAppDate;
    improved?: boolean;
    provenances?: Set<TAppProvenance>;
    provenanceDescriptors?: Set<string>;
}
export class TAppProfessionalInfo {
    public jobTitle?: string;
    public departmentName?: string;
    public companyName?: string;
    public startDate?: TAppDate;
    public endDate?: TAppDate;
    public improved?: boolean;
    public provenances?: Set<TAppProvenance>;
    public provenanceDescriptors?: Set<string>;
    constructor(args?: ITAppProfessionalInfoArgs) {
        if (args != null && args.jobTitle != null) {
            this.jobTitle = args.jobTitle;
        }
        if (args != null && args.departmentName != null) {
            this.departmentName = args.departmentName;
        }
        if (args != null && args.companyName != null) {
            this.companyName = args.companyName;
        }
        if (args != null && args.startDate != null) {
            this.startDate = args.startDate;
        }
        if (args != null && args.endDate != null) {
            this.endDate = args.endDate;
        }
        if (args != null && args.improved != null) {
            this.improved = args.improved;
        }
        if (args != null && args.provenances != null) {
            this.provenances = args.provenances;
        }
        if (args != null && args.provenanceDescriptors != null) {
            this.provenanceDescriptors = args.provenanceDescriptors;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppProfessionalInfo");
        if (this.jobTitle != null) {
            output.writeFieldBegin("jobTitle", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.jobTitle);
            output.writeFieldEnd();
        }
        if (this.departmentName != null) {
            output.writeFieldBegin("departmentName", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.departmentName);
            output.writeFieldEnd();
        }
        if (this.companyName != null) {
            output.writeFieldBegin("companyName", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.companyName);
            output.writeFieldEnd();
        }
        if (this.startDate != null) {
            output.writeFieldBegin("startDate", thrift.Thrift.Type.STRUCT, 4);
            this.startDate.write(output);
            output.writeFieldEnd();
        }
        if (this.endDate != null) {
            output.writeFieldBegin("endDate", thrift.Thrift.Type.STRUCT, 5);
            this.endDate.write(output);
            output.writeFieldEnd();
        }
        if (this.improved != null) {
            output.writeFieldBegin("improved", thrift.Thrift.Type.BOOL, 7);
            output.writeBool(this.improved);
            output.writeFieldEnd();
        }
        if (this.provenances != null) {
            output.writeFieldBegin("provenances", thrift.Thrift.Type.SET, 8);
            output.writeSetBegin(thrift.Thrift.Type.I32, this.provenances.size);
            this.provenances.forEach((value_70: TAppProvenance): void => {
                output.writeI32(value_70);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        if (this.provenanceDescriptors != null) {
            output.writeFieldBegin("provenanceDescriptors", thrift.Thrift.Type.SET, 9);
            output.writeSetBegin(thrift.Thrift.Type.STRING, this.provenanceDescriptors.size);
            this.provenanceDescriptors.forEach((value_71: string): void => {
                output.writeString(value_71);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppProfessionalInfo {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_72: string = input.readString();
                        _args.jobTitle = value_72;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_73: string = input.readString();
                        _args.departmentName = value_73;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_74: string = input.readString();
                        _args.companyName = value_74;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_75: TAppDate = TAppDate.read(input);
                        _args.startDate = value_75;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_76: TAppDate = TAppDate.read(input);
                        _args.endDate = value_76;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_77: boolean = input.readBool();
                        _args.improved = value_77;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_78: Set<TAppProvenance> = new Set<TAppProvenance>();
                        const metadata_12: thrift.TSet = input.readSetBegin();
                        const size_12: number = metadata_12.size;
                        for (let i_12: number = 0; i_12 < size_12; i_12++) {
                            const value_79: TAppProvenance = input.readI32();
                            value_78.add(value_79);
                        }
                        input.readSetEnd();
                        _args.provenances = value_78;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_80: Set<string> = new Set<string>();
                        const metadata_13: thrift.TSet = input.readSetBegin();
                        const size_13: number = metadata_13.size;
                        for (let i_13: number = 0; i_13 < size_13; i_13++) {
                            const value_81: string = input.readString();
                            value_80.add(value_81);
                        }
                        input.readSetEnd();
                        _args.provenanceDescriptors = value_80;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppProfessionalInfo(_args);
    }
}
export interface ITAppThirdPartyIdArgs {
    sourceName?: string;
    source?: TAppThirdPartyIdSource;
    value?: string;
    deepLink?: string;
    url?: string;
    isInactive?: boolean;
    skipExport?: boolean;
    improved?: boolean;
    provenances?: Set<TAppProvenance>;
    provenanceDescriptors?: Set<string>;
}
export class TAppThirdPartyId {
    public sourceName?: string;
    public source?: TAppThirdPartyIdSource;
    public value?: string;
    public deepLink?: string;
    public url?: string;
    public isInactive?: boolean;
    public skipExport?: boolean;
    public improved?: boolean;
    public provenances?: Set<TAppProvenance>;
    public provenanceDescriptors?: Set<string>;
    constructor(args?: ITAppThirdPartyIdArgs) {
        if (args != null && args.sourceName != null) {
            this.sourceName = args.sourceName;
        }
        if (args != null && args.source != null) {
            this.source = args.source;
        }
        if (args != null && args.value != null) {
            this.value = args.value;
        }
        if (args != null && args.deepLink != null) {
            this.deepLink = args.deepLink;
        }
        if (args != null && args.url != null) {
            this.url = args.url;
        }
        if (args != null && args.isInactive != null) {
            this.isInactive = args.isInactive;
        }
        if (args != null && args.skipExport != null) {
            this.skipExport = args.skipExport;
        }
        if (args != null && args.improved != null) {
            this.improved = args.improved;
        }
        if (args != null && args.provenances != null) {
            this.provenances = args.provenances;
        }
        if (args != null && args.provenanceDescriptors != null) {
            this.provenanceDescriptors = args.provenanceDescriptors;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppThirdPartyId");
        if (this.sourceName != null) {
            output.writeFieldBegin("sourceName", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.sourceName);
            output.writeFieldEnd();
        }
        if (this.source != null) {
            output.writeFieldBegin("source", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.source);
            output.writeFieldEnd();
        }
        if (this.value != null) {
            output.writeFieldBegin("value", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.value);
            output.writeFieldEnd();
        }
        if (this.deepLink != null) {
            output.writeFieldBegin("deepLink", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.deepLink);
            output.writeFieldEnd();
        }
        if (this.url != null) {
            output.writeFieldBegin("url", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.url);
            output.writeFieldEnd();
        }
        if (this.isInactive != null) {
            output.writeFieldBegin("isInactive", thrift.Thrift.Type.BOOL, 7);
            output.writeBool(this.isInactive);
            output.writeFieldEnd();
        }
        if (this.skipExport != null) {
            output.writeFieldBegin("skipExport", thrift.Thrift.Type.BOOL, 8);
            output.writeBool(this.skipExport);
            output.writeFieldEnd();
        }
        if (this.improved != null) {
            output.writeFieldBegin("improved", thrift.Thrift.Type.BOOL, 10);
            output.writeBool(this.improved);
            output.writeFieldEnd();
        }
        if (this.provenances != null) {
            output.writeFieldBegin("provenances", thrift.Thrift.Type.SET, 11);
            output.writeSetBegin(thrift.Thrift.Type.I32, this.provenances.size);
            this.provenances.forEach((value_82: TAppProvenance): void => {
                output.writeI32(value_82);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        if (this.provenanceDescriptors != null) {
            output.writeFieldBegin("provenanceDescriptors", thrift.Thrift.Type.SET, 12);
            output.writeSetBegin(thrift.Thrift.Type.STRING, this.provenanceDescriptors.size);
            this.provenanceDescriptors.forEach((value_83: string): void => {
                output.writeString(value_83);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppThirdPartyId {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_84: string = input.readString();
                        _args.sourceName = value_84;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_85: TAppThirdPartyIdSource = input.readI32();
                        _args.source = value_85;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_86: string = input.readString();
                        _args.value = value_86;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_87: string = input.readString();
                        _args.deepLink = value_87;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_88: string = input.readString();
                        _args.url = value_88;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_89: boolean = input.readBool();
                        _args.isInactive = value_89;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_90: boolean = input.readBool();
                        _args.skipExport = value_90;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_91: boolean = input.readBool();
                        _args.improved = value_91;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_92: Set<TAppProvenance> = new Set<TAppProvenance>();
                        const metadata_14: thrift.TSet = input.readSetBegin();
                        const size_14: number = metadata_14.size;
                        for (let i_14: number = 0; i_14 < size_14; i_14++) {
                            const value_93: TAppProvenance = input.readI32();
                            value_92.add(value_93);
                        }
                        input.readSetEnd();
                        _args.provenances = value_92;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_94: Set<string> = new Set<string>();
                        const metadata_15: thrift.TSet = input.readSetBegin();
                        const size_15: number = metadata_15.size;
                        for (let i_15: number = 0; i_15 < size_15; i_15++) {
                            const value_95: string = input.readString();
                            value_94.add(value_95);
                        }
                        input.readSetEnd();
                        _args.provenanceDescriptors = value_94;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppThirdPartyId(_args);
    }
}
export interface ITAppPhotoArgs {
    photoUrl: string;
    improved?: boolean;
    provenances?: Set<TAppProvenance>;
    provenanceDescriptors?: Set<string>;
}
export class TAppPhoto {
    public photoUrl: string;
    public improved?: boolean;
    public provenances?: Set<TAppProvenance>;
    public provenanceDescriptors?: Set<string>;
    constructor(args: ITAppPhotoArgs) {
        if (args != null && args.photoUrl != null) {
            this.photoUrl = args.photoUrl;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoUrl] is unset!");
        }
        if (args != null && args.improved != null) {
            this.improved = args.improved;
        }
        if (args != null && args.provenances != null) {
            this.provenances = args.provenances;
        }
        if (args != null && args.provenanceDescriptors != null) {
            this.provenanceDescriptors = args.provenanceDescriptors;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoto");
        if (this.photoUrl != null) {
            output.writeFieldBegin("photoUrl", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.photoUrl);
            output.writeFieldEnd();
        }
        if (this.improved != null) {
            output.writeFieldBegin("improved", thrift.Thrift.Type.BOOL, 3);
            output.writeBool(this.improved);
            output.writeFieldEnd();
        }
        if (this.provenances != null) {
            output.writeFieldBegin("provenances", thrift.Thrift.Type.SET, 4);
            output.writeSetBegin(thrift.Thrift.Type.I32, this.provenances.size);
            this.provenances.forEach((value_96: TAppProvenance): void => {
                output.writeI32(value_96);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        if (this.provenanceDescriptors != null) {
            output.writeFieldBegin("provenanceDescriptors", thrift.Thrift.Type.SET, 5);
            output.writeSetBegin(thrift.Thrift.Type.STRING, this.provenanceDescriptors.size);
            this.provenanceDescriptors.forEach((value_97: string): void => {
                output.writeString(value_97);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoto {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_98: string = input.readString();
                        _args.photoUrl = value_98;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_99: boolean = input.readBool();
                        _args.improved = value_99;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_100: Set<TAppProvenance> = new Set<TAppProvenance>();
                        const metadata_16: thrift.TSet = input.readSetBegin();
                        const size_16: number = metadata_16.size;
                        for (let i_16: number = 0; i_16 < size_16; i_16++) {
                            const value_101: TAppProvenance = input.readI32();
                            value_100.add(value_101);
                        }
                        input.readSetEnd();
                        _args.provenances = value_100;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_102: Set<string> = new Set<string>();
                        const metadata_17: thrift.TSet = input.readSetBegin();
                        const size_17: number = metadata_17.size;
                        for (let i_17: number = 0; i_17 < size_17; i_17++) {
                            const value_103: string = input.readString();
                            value_102.add(value_103);
                        }
                        input.readSetEnd();
                        _args.provenanceDescriptors = value_102;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.photoUrl !== undefined) {
            return new TAppPhoto(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoto from input");
        }
    }
}
export interface ITAppContactIdArgs {
    uuid?: string;
    containerId?: string;
    clientEditSeqIds?: Map<TAppProvenance, number>;
    action?: TAppExportAction;
    name?: TAppName;
    deviceId?: string;
}
export class TAppContactId {
    public uuid?: string;
    public containerId?: string;
    public clientEditSeqIds?: Map<TAppProvenance, number>;
    public action?: TAppExportAction;
    public name?: TAppName;
    public deviceId?: string;
    constructor(args?: ITAppContactIdArgs) {
        if (args != null && args.uuid != null) {
            this.uuid = args.uuid;
        }
        if (args != null && args.containerId != null) {
            this.containerId = args.containerId;
        }
        if (args != null && args.clientEditSeqIds != null) {
            this.clientEditSeqIds = args.clientEditSeqIds;
        }
        if (args != null && args.action != null) {
            this.action = args.action;
        }
        if (args != null && args.name != null) {
            this.name = args.name;
        }
        if (args != null && args.deviceId != null) {
            this.deviceId = args.deviceId;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppContactId");
        if (this.uuid != null) {
            output.writeFieldBegin("uuid", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.uuid);
            output.writeFieldEnd();
        }
        if (this.containerId != null) {
            output.writeFieldBegin("containerId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.containerId);
            output.writeFieldEnd();
        }
        if (this.clientEditSeqIds != null) {
            output.writeFieldBegin("clientEditSeqIds", thrift.Thrift.Type.MAP, 3);
            output.writeMapBegin(thrift.Thrift.Type.I32, thrift.Thrift.Type.I32, this.clientEditSeqIds.size);
            this.clientEditSeqIds.forEach((value_104: number, key_1: TAppProvenance): void => {
                output.writeI32(key_1);
                output.writeI32(value_104);
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        if (this.action != null) {
            output.writeFieldBegin("action", thrift.Thrift.Type.I32, 4);
            output.writeI32(this.action);
            output.writeFieldEnd();
        }
        if (this.name != null) {
            output.writeFieldBegin("name", thrift.Thrift.Type.STRUCT, 5);
            this.name.write(output);
            output.writeFieldEnd();
        }
        if (this.deviceId != null) {
            output.writeFieldBegin("deviceId", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.deviceId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppContactId {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_105: string = input.readString();
                        _args.uuid = value_105;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_106: string = input.readString();
                        _args.containerId = value_106;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_107: Map<TAppProvenance, number> = new Map<TAppProvenance, number>();
                        const metadata_18: thrift.TMap = input.readMapBegin();
                        const size_18: number = metadata_18.size;
                        for (let i_18: number = 0; i_18 < size_18; i_18++) {
                            const key_2: TAppProvenance = input.readI32();
                            const value_108: number = input.readI32();
                            value_107.set(key_2, value_108);
                        }
                        input.readMapEnd();
                        _args.clientEditSeqIds = value_107;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_109: TAppExportAction = input.readI32();
                        _args.action = value_109;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_110: TAppName = TAppName.read(input);
                        _args.name = value_110;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_111: string = input.readString();
                        _args.deviceId = value_111;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppContactId(_args);
    }
}
export interface ITAppEmailMessageArgs {
    fromEmailAddress?: string;
    toEmailAddresses?: Array<string>;
    ccEmailAddresses?: Array<string>;
    subject?: string;
    timestampSec?: number | Int64;
    messageSnippet?: string;
    gmailDeepLink?: string;
    appleMailDeepLink?: string;
}
export class TAppEmailMessage {
    public fromEmailAddress?: string;
    public toEmailAddresses?: Array<string>;
    public ccEmailAddresses?: Array<string>;
    public subject?: string;
    public timestampSec?: Int64;
    public messageSnippet?: string;
    public gmailDeepLink?: string;
    public appleMailDeepLink?: string;
    constructor(args?: ITAppEmailMessageArgs) {
        if (args != null && args.fromEmailAddress != null) {
            this.fromEmailAddress = args.fromEmailAddress;
        }
        if (args != null && args.toEmailAddresses != null) {
            this.toEmailAddresses = args.toEmailAddresses;
        }
        if (args != null && args.ccEmailAddresses != null) {
            this.ccEmailAddresses = args.ccEmailAddresses;
        }
        if (args != null && args.subject != null) {
            this.subject = args.subject;
        }
        if (args != null && args.timestampSec != null) {
            if (typeof args.timestampSec === "number") {
                this.timestampSec = new Int64(args.timestampSec);
            }
            else {
                this.timestampSec = args.timestampSec;
            }
        }
        if (args != null && args.messageSnippet != null) {
            this.messageSnippet = args.messageSnippet;
        }
        if (args != null && args.gmailDeepLink != null) {
            this.gmailDeepLink = args.gmailDeepLink;
        }
        if (args != null && args.appleMailDeepLink != null) {
            this.appleMailDeepLink = args.appleMailDeepLink;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEmailMessage");
        if (this.fromEmailAddress != null) {
            output.writeFieldBegin("fromEmailAddress", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.fromEmailAddress);
            output.writeFieldEnd();
        }
        if (this.toEmailAddresses != null) {
            output.writeFieldBegin("toEmailAddresses", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.toEmailAddresses.length);
            this.toEmailAddresses.forEach((value_112: string): void => {
                output.writeString(value_112);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.ccEmailAddresses != null) {
            output.writeFieldBegin("ccEmailAddresses", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.ccEmailAddresses.length);
            this.ccEmailAddresses.forEach((value_113: string): void => {
                output.writeString(value_113);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.subject != null) {
            output.writeFieldBegin("subject", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.subject);
            output.writeFieldEnd();
        }
        if (this.timestampSec != null) {
            output.writeFieldBegin("timestampSec", thrift.Thrift.Type.I64, 5);
            output.writeI64(this.timestampSec);
            output.writeFieldEnd();
        }
        if (this.messageSnippet != null) {
            output.writeFieldBegin("messageSnippet", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.messageSnippet);
            output.writeFieldEnd();
        }
        if (this.gmailDeepLink != null) {
            output.writeFieldBegin("gmailDeepLink", thrift.Thrift.Type.STRING, 7);
            output.writeString(this.gmailDeepLink);
            output.writeFieldEnd();
        }
        if (this.appleMailDeepLink != null) {
            output.writeFieldBegin("appleMailDeepLink", thrift.Thrift.Type.STRING, 8);
            output.writeString(this.appleMailDeepLink);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEmailMessage {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_114: string = input.readString();
                        _args.fromEmailAddress = value_114;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_115: Array<string> = new Array<string>();
                        const metadata_19: thrift.TList = input.readListBegin();
                        const size_19: number = metadata_19.size;
                        for (let i_19: number = 0; i_19 < size_19; i_19++) {
                            const value_116: string = input.readString();
                            value_115.push(value_116);
                        }
                        input.readListEnd();
                        _args.toEmailAddresses = value_115;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_117: Array<string> = new Array<string>();
                        const metadata_20: thrift.TList = input.readListBegin();
                        const size_20: number = metadata_20.size;
                        for (let i_20: number = 0; i_20 < size_20; i_20++) {
                            const value_118: string = input.readString();
                            value_117.push(value_118);
                        }
                        input.readListEnd();
                        _args.ccEmailAddresses = value_117;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_119: string = input.readString();
                        _args.subject = value_119;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_120: Int64 = input.readI64();
                        _args.timestampSec = value_120;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_121: string = input.readString();
                        _args.messageSnippet = value_121;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_122: string = input.readString();
                        _args.gmailDeepLink = value_122;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_123: string = input.readString();
                        _args.appleMailDeepLink = value_123;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppEmailMessage(_args);
    }
}
export interface ITAppContactContextArgs {
    overwrittenValues?: Array<string>;
}
export class TAppContactContext {
    public overwrittenValues?: Array<string>;
    constructor(args?: ITAppContactContextArgs) {
        if (args != null && args.overwrittenValues != null) {
            this.overwrittenValues = args.overwrittenValues;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppContactContext");
        if (this.overwrittenValues != null) {
            output.writeFieldBegin("overwrittenValues", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.overwrittenValues.length);
            this.overwrittenValues.forEach((value_124: string): void => {
                output.writeString(value_124);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppContactContext {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_125: Array<string> = new Array<string>();
                        const metadata_21: thrift.TList = input.readListBegin();
                        const size_21: number = metadata_21.size;
                        for (let i_21: number = 0; i_21 < size_21; i_21++) {
                            const value_126: string = input.readString();
                            value_125.push(value_126);
                        }
                        input.readListEnd();
                        _args.overwrittenValues = value_125;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppContactContext(_args);
    }
}
export interface ITAppRelationArgs {
    unparsedRelation?: string;
}
export class TAppRelation {
    public unparsedRelation?: string;
    constructor(args?: ITAppRelationArgs) {
        if (args != null && args.unparsedRelation != null) {
            this.unparsedRelation = args.unparsedRelation;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppRelation");
        if (this.unparsedRelation != null) {
            output.writeFieldBegin("unparsedRelation", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.unparsedRelation);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppRelation {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_127: string = input.readString();
                        _args.unparsedRelation = value_127;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppRelation(_args);
    }
}
export interface ITAppContactMetadataArgs {
}
export class TAppContactMetadata {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppContactMetadata");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppContactMetadata {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppContactMetadata();
    }
}
export interface ITAppContactArgs {
    contactId?: string;
    name?: TAppName;
    photoUrl?: string;
    photo?: TAppPhoto;
    primaryMobile?: TAppPhone;
    personalMobile?: TAppPhone;
    personalLandline?: TAppPhone;
    personalEmail?: TAppEmail;
    personalAddress?: TAppAddress;
    personalThirdPartyIds?: Array<TAppThirdPartyId>;
    birthday?: TAppDate;
    professionalMobile?: TAppPhone;
    professionalLandline?: TAppPhone;
    professionalEmail?: TAppEmail;
    professionalAddress?: TAppAddress;
    professionalThirdPartyIds?: Array<TAppThirdPartyId>;
    primaryProfessionalInfo?: TAppProfessionalInfo;
    otherPhones?: Array<TAppPhone>;
    otherEmails?: Array<TAppEmail>;
    otherAddresses?: Array<TAppAddress>;
    otherThirdPartyIds?: Array<TAppThirdPartyId>;
    otherProfessionalInfos?: Array<TAppProfessionalInfo>;
    archived?: boolean;
    improved?: boolean;
    originalContactIds?: Array<TAppContactId>;
    editSequenceId?: number | Int64;
    contactUserId?: string;
    contextEmail?: TAppEmailMessage;
    context?: TAppContactContext;
    serverEditSeqId?: string;
    hasNotes?: boolean;
    provenances?: Set<TAppProvenance>;
    birthdayPreferences?: Array<TAppBirthdayPreference>;
    notificationMode?: PAppNotifications.TAppNotificationPreferenceMode;
    contactType?: TAppContactType;
    contactMetadata?: TAppContactMetadata;
    relation?: TAppRelation;
}
export class TAppContact {
    public contactId?: string;
    public name?: TAppName;
    public photoUrl?: string;
    public photo?: TAppPhoto;
    public primaryMobile?: TAppPhone;
    public personalMobile?: TAppPhone;
    public personalLandline?: TAppPhone;
    public personalEmail?: TAppEmail;
    public personalAddress?: TAppAddress;
    public personalThirdPartyIds?: Array<TAppThirdPartyId>;
    public birthday?: TAppDate;
    public professionalMobile?: TAppPhone;
    public professionalLandline?: TAppPhone;
    public professionalEmail?: TAppEmail;
    public professionalAddress?: TAppAddress;
    public professionalThirdPartyIds?: Array<TAppThirdPartyId>;
    public primaryProfessionalInfo?: TAppProfessionalInfo;
    public otherPhones?: Array<TAppPhone>;
    public otherEmails?: Array<TAppEmail>;
    public otherAddresses?: Array<TAppAddress>;
    public otherThirdPartyIds?: Array<TAppThirdPartyId>;
    public otherProfessionalInfos?: Array<TAppProfessionalInfo>;
    public archived?: boolean;
    public improved?: boolean;
    public originalContactIds?: Array<TAppContactId>;
    public editSequenceId?: Int64;
    public contactUserId?: string;
    public contextEmail?: TAppEmailMessage;
    public context?: TAppContactContext;
    public serverEditSeqId?: string;
    public hasNotes?: boolean;
    public provenances?: Set<TAppProvenance>;
    public birthdayPreferences?: Array<TAppBirthdayPreference>;
    public notificationMode?: PAppNotifications.TAppNotificationPreferenceMode;
    public contactType?: TAppContactType;
    public contactMetadata?: TAppContactMetadata;
    public relation?: TAppRelation;
    constructor(args?: ITAppContactArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        if (args != null && args.name != null) {
            this.name = args.name;
        }
        if (args != null && args.photoUrl != null) {
            this.photoUrl = args.photoUrl;
        }
        if (args != null && args.photo != null) {
            this.photo = args.photo;
        }
        if (args != null && args.primaryMobile != null) {
            this.primaryMobile = args.primaryMobile;
        }
        if (args != null && args.personalMobile != null) {
            this.personalMobile = args.personalMobile;
        }
        if (args != null && args.personalLandline != null) {
            this.personalLandline = args.personalLandline;
        }
        if (args != null && args.personalEmail != null) {
            this.personalEmail = args.personalEmail;
        }
        if (args != null && args.personalAddress != null) {
            this.personalAddress = args.personalAddress;
        }
        if (args != null && args.personalThirdPartyIds != null) {
            this.personalThirdPartyIds = args.personalThirdPartyIds;
        }
        if (args != null && args.birthday != null) {
            this.birthday = args.birthday;
        }
        if (args != null && args.professionalMobile != null) {
            this.professionalMobile = args.professionalMobile;
        }
        if (args != null && args.professionalLandline != null) {
            this.professionalLandline = args.professionalLandline;
        }
        if (args != null && args.professionalEmail != null) {
            this.professionalEmail = args.professionalEmail;
        }
        if (args != null && args.professionalAddress != null) {
            this.professionalAddress = args.professionalAddress;
        }
        if (args != null && args.professionalThirdPartyIds != null) {
            this.professionalThirdPartyIds = args.professionalThirdPartyIds;
        }
        if (args != null && args.primaryProfessionalInfo != null) {
            this.primaryProfessionalInfo = args.primaryProfessionalInfo;
        }
        if (args != null && args.otherPhones != null) {
            this.otherPhones = args.otherPhones;
        }
        if (args != null && args.otherEmails != null) {
            this.otherEmails = args.otherEmails;
        }
        if (args != null && args.otherAddresses != null) {
            this.otherAddresses = args.otherAddresses;
        }
        if (args != null && args.otherThirdPartyIds != null) {
            this.otherThirdPartyIds = args.otherThirdPartyIds;
        }
        if (args != null && args.otherProfessionalInfos != null) {
            this.otherProfessionalInfos = args.otherProfessionalInfos;
        }
        if (args != null && args.archived != null) {
            this.archived = args.archived;
        }
        if (args != null && args.improved != null) {
            this.improved = args.improved;
        }
        if (args != null && args.originalContactIds != null) {
            this.originalContactIds = args.originalContactIds;
        }
        if (args != null && args.editSequenceId != null) {
            if (typeof args.editSequenceId === "number") {
                this.editSequenceId = new Int64(args.editSequenceId);
            }
            else {
                this.editSequenceId = args.editSequenceId;
            }
        }
        if (args != null && args.contactUserId != null) {
            this.contactUserId = args.contactUserId;
        }
        if (args != null && args.contextEmail != null) {
            this.contextEmail = args.contextEmail;
        }
        if (args != null && args.context != null) {
            this.context = args.context;
        }
        if (args != null && args.serverEditSeqId != null) {
            this.serverEditSeqId = args.serverEditSeqId;
        }
        if (args != null && args.hasNotes != null) {
            this.hasNotes = args.hasNotes;
        }
        if (args != null && args.provenances != null) {
            this.provenances = args.provenances;
        }
        if (args != null && args.birthdayPreferences != null) {
            this.birthdayPreferences = args.birthdayPreferences;
        }
        if (args != null && args.notificationMode != null) {
            this.notificationMode = args.notificationMode;
        }
        if (args != null && args.contactType != null) {
            this.contactType = args.contactType;
        }
        if (args != null && args.contactMetadata != null) {
            this.contactMetadata = args.contactMetadata;
        }
        if (args != null && args.relation != null) {
            this.relation = args.relation;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppContact");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.name != null) {
            output.writeFieldBegin("name", thrift.Thrift.Type.STRUCT, 2);
            this.name.write(output);
            output.writeFieldEnd();
        }
        if (this.photoUrl != null) {
            output.writeFieldBegin("photoUrl", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.photoUrl);
            output.writeFieldEnd();
        }
        if (this.photo != null) {
            output.writeFieldBegin("photo", thrift.Thrift.Type.STRUCT, 39);
            this.photo.write(output);
            output.writeFieldEnd();
        }
        if (this.primaryMobile != null) {
            output.writeFieldBegin("primaryMobile", thrift.Thrift.Type.STRUCT, 32);
            this.primaryMobile.write(output);
            output.writeFieldEnd();
        }
        if (this.personalMobile != null) {
            output.writeFieldBegin("personalMobile", thrift.Thrift.Type.STRUCT, 4);
            this.personalMobile.write(output);
            output.writeFieldEnd();
        }
        if (this.personalLandline != null) {
            output.writeFieldBegin("personalLandline", thrift.Thrift.Type.STRUCT, 5);
            this.personalLandline.write(output);
            output.writeFieldEnd();
        }
        if (this.personalEmail != null) {
            output.writeFieldBegin("personalEmail", thrift.Thrift.Type.STRUCT, 6);
            this.personalEmail.write(output);
            output.writeFieldEnd();
        }
        if (this.personalAddress != null) {
            output.writeFieldBegin("personalAddress", thrift.Thrift.Type.STRUCT, 7);
            this.personalAddress.write(output);
            output.writeFieldEnd();
        }
        if (this.personalThirdPartyIds != null) {
            output.writeFieldBegin("personalThirdPartyIds", thrift.Thrift.Type.LIST, 8);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.personalThirdPartyIds.length);
            this.personalThirdPartyIds.forEach((value_128: TAppThirdPartyId): void => {
                value_128.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.birthday != null) {
            output.writeFieldBegin("birthday", thrift.Thrift.Type.STRUCT, 9);
            this.birthday.write(output);
            output.writeFieldEnd();
        }
        if (this.professionalMobile != null) {
            output.writeFieldBegin("professionalMobile", thrift.Thrift.Type.STRUCT, 10);
            this.professionalMobile.write(output);
            output.writeFieldEnd();
        }
        if (this.professionalLandline != null) {
            output.writeFieldBegin("professionalLandline", thrift.Thrift.Type.STRUCT, 11);
            this.professionalLandline.write(output);
            output.writeFieldEnd();
        }
        if (this.professionalEmail != null) {
            output.writeFieldBegin("professionalEmail", thrift.Thrift.Type.STRUCT, 12);
            this.professionalEmail.write(output);
            output.writeFieldEnd();
        }
        if (this.professionalAddress != null) {
            output.writeFieldBegin("professionalAddress", thrift.Thrift.Type.STRUCT, 13);
            this.professionalAddress.write(output);
            output.writeFieldEnd();
        }
        if (this.professionalThirdPartyIds != null) {
            output.writeFieldBegin("professionalThirdPartyIds", thrift.Thrift.Type.LIST, 14);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.professionalThirdPartyIds.length);
            this.professionalThirdPartyIds.forEach((value_129: TAppThirdPartyId): void => {
                value_129.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.primaryProfessionalInfo != null) {
            output.writeFieldBegin("primaryProfessionalInfo", thrift.Thrift.Type.STRUCT, 15);
            this.primaryProfessionalInfo.write(output);
            output.writeFieldEnd();
        }
        if (this.otherPhones != null) {
            output.writeFieldBegin("otherPhones", thrift.Thrift.Type.LIST, 16);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.otherPhones.length);
            this.otherPhones.forEach((value_130: TAppPhone): void => {
                value_130.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.otherEmails != null) {
            output.writeFieldBegin("otherEmails", thrift.Thrift.Type.LIST, 17);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.otherEmails.length);
            this.otherEmails.forEach((value_131: TAppEmail): void => {
                value_131.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.otherAddresses != null) {
            output.writeFieldBegin("otherAddresses", thrift.Thrift.Type.LIST, 18);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.otherAddresses.length);
            this.otherAddresses.forEach((value_132: TAppAddress): void => {
                value_132.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.otherThirdPartyIds != null) {
            output.writeFieldBegin("otherThirdPartyIds", thrift.Thrift.Type.LIST, 19);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.otherThirdPartyIds.length);
            this.otherThirdPartyIds.forEach((value_133: TAppThirdPartyId): void => {
                value_133.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.otherProfessionalInfos != null) {
            output.writeFieldBegin("otherProfessionalInfos", thrift.Thrift.Type.LIST, 24);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.otherProfessionalInfos.length);
            this.otherProfessionalInfos.forEach((value_134: TAppProfessionalInfo): void => {
                value_134.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.archived != null) {
            output.writeFieldBegin("archived", thrift.Thrift.Type.BOOL, 20);
            output.writeBool(this.archived);
            output.writeFieldEnd();
        }
        if (this.improved != null) {
            output.writeFieldBegin("improved", thrift.Thrift.Type.BOOL, 21);
            output.writeBool(this.improved);
            output.writeFieldEnd();
        }
        if (this.originalContactIds != null) {
            output.writeFieldBegin("originalContactIds", thrift.Thrift.Type.LIST, 26);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.originalContactIds.length);
            this.originalContactIds.forEach((value_135: TAppContactId): void => {
                value_135.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.editSequenceId != null) {
            output.writeFieldBegin("editSequenceId", thrift.Thrift.Type.I64, 23);
            output.writeI64(this.editSequenceId);
            output.writeFieldEnd();
        }
        if (this.contactUserId != null) {
            output.writeFieldBegin("contactUserId", thrift.Thrift.Type.STRING, 27);
            output.writeString(this.contactUserId);
            output.writeFieldEnd();
        }
        if (this.contextEmail != null) {
            output.writeFieldBegin("contextEmail", thrift.Thrift.Type.STRUCT, 28);
            this.contextEmail.write(output);
            output.writeFieldEnd();
        }
        if (this.context != null) {
            output.writeFieldBegin("context", thrift.Thrift.Type.STRUCT, 29);
            this.context.write(output);
            output.writeFieldEnd();
        }
        if (this.serverEditSeqId != null) {
            output.writeFieldBegin("serverEditSeqId", thrift.Thrift.Type.STRING, 30);
            output.writeString(this.serverEditSeqId);
            output.writeFieldEnd();
        }
        if (this.hasNotes != null) {
            output.writeFieldBegin("hasNotes", thrift.Thrift.Type.BOOL, 31);
            output.writeBool(this.hasNotes);
            output.writeFieldEnd();
        }
        if (this.provenances != null) {
            output.writeFieldBegin("provenances", thrift.Thrift.Type.SET, 33);
            output.writeSetBegin(thrift.Thrift.Type.I32, this.provenances.size);
            this.provenances.forEach((value_136: TAppProvenance): void => {
                output.writeI32(value_136);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        if (this.birthdayPreferences != null) {
            output.writeFieldBegin("birthdayPreferences", thrift.Thrift.Type.LIST, 34);
            output.writeListBegin(thrift.Thrift.Type.I32, this.birthdayPreferences.length);
            this.birthdayPreferences.forEach((value_137: TAppBirthdayPreference): void => {
                output.writeI32(value_137);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.notificationMode != null) {
            output.writeFieldBegin("notificationMode", thrift.Thrift.Type.I32, 35);
            output.writeI32(this.notificationMode);
            output.writeFieldEnd();
        }
        if (this.contactType != null) {
            output.writeFieldBegin("contactType", thrift.Thrift.Type.I32, 36);
            output.writeI32(this.contactType);
            output.writeFieldEnd();
        }
        if (this.contactMetadata != null) {
            output.writeFieldBegin("contactMetadata", thrift.Thrift.Type.STRUCT, 37);
            this.contactMetadata.write(output);
            output.writeFieldEnd();
        }
        if (this.relation != null) {
            output.writeFieldBegin("relation", thrift.Thrift.Type.STRUCT, 38);
            this.relation.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppContact {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_138: string = input.readString();
                        _args.contactId = value_138;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_139: TAppName = TAppName.read(input);
                        _args.name = value_139;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_140: string = input.readString();
                        _args.photoUrl = value_140;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 39:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_141: TAppPhoto = TAppPhoto.read(input);
                        _args.photo = value_141;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 32:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_142: TAppPhone = TAppPhone.read(input);
                        _args.primaryMobile = value_142;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_143: TAppPhone = TAppPhone.read(input);
                        _args.personalMobile = value_143;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_144: TAppPhone = TAppPhone.read(input);
                        _args.personalLandline = value_144;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_145: TAppEmail = TAppEmail.read(input);
                        _args.personalEmail = value_145;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_146: TAppAddress = TAppAddress.read(input);
                        _args.personalAddress = value_146;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_147: Array<TAppThirdPartyId> = new Array<TAppThirdPartyId>();
                        const metadata_22: thrift.TList = input.readListBegin();
                        const size_22: number = metadata_22.size;
                        for (let i_22: number = 0; i_22 < size_22; i_22++) {
                            const value_148: TAppThirdPartyId = TAppThirdPartyId.read(input);
                            value_147.push(value_148);
                        }
                        input.readListEnd();
                        _args.personalThirdPartyIds = value_147;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_149: TAppDate = TAppDate.read(input);
                        _args.birthday = value_149;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_150: TAppPhone = TAppPhone.read(input);
                        _args.professionalMobile = value_150;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_151: TAppPhone = TAppPhone.read(input);
                        _args.professionalLandline = value_151;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_152: TAppEmail = TAppEmail.read(input);
                        _args.professionalEmail = value_152;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 13:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_153: TAppAddress = TAppAddress.read(input);
                        _args.professionalAddress = value_153;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 14:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_154: Array<TAppThirdPartyId> = new Array<TAppThirdPartyId>();
                        const metadata_23: thrift.TList = input.readListBegin();
                        const size_23: number = metadata_23.size;
                        for (let i_23: number = 0; i_23 < size_23; i_23++) {
                            const value_155: TAppThirdPartyId = TAppThirdPartyId.read(input);
                            value_154.push(value_155);
                        }
                        input.readListEnd();
                        _args.professionalThirdPartyIds = value_154;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 15:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_156: TAppProfessionalInfo = TAppProfessionalInfo.read(input);
                        _args.primaryProfessionalInfo = value_156;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 16:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_157: Array<TAppPhone> = new Array<TAppPhone>();
                        const metadata_24: thrift.TList = input.readListBegin();
                        const size_24: number = metadata_24.size;
                        for (let i_24: number = 0; i_24 < size_24; i_24++) {
                            const value_158: TAppPhone = TAppPhone.read(input);
                            value_157.push(value_158);
                        }
                        input.readListEnd();
                        _args.otherPhones = value_157;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 17:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_159: Array<TAppEmail> = new Array<TAppEmail>();
                        const metadata_25: thrift.TList = input.readListBegin();
                        const size_25: number = metadata_25.size;
                        for (let i_25: number = 0; i_25 < size_25; i_25++) {
                            const value_160: TAppEmail = TAppEmail.read(input);
                            value_159.push(value_160);
                        }
                        input.readListEnd();
                        _args.otherEmails = value_159;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 18:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_161: Array<TAppAddress> = new Array<TAppAddress>();
                        const metadata_26: thrift.TList = input.readListBegin();
                        const size_26: number = metadata_26.size;
                        for (let i_26: number = 0; i_26 < size_26; i_26++) {
                            const value_162: TAppAddress = TAppAddress.read(input);
                            value_161.push(value_162);
                        }
                        input.readListEnd();
                        _args.otherAddresses = value_161;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 19:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_163: Array<TAppThirdPartyId> = new Array<TAppThirdPartyId>();
                        const metadata_27: thrift.TList = input.readListBegin();
                        const size_27: number = metadata_27.size;
                        for (let i_27: number = 0; i_27 < size_27; i_27++) {
                            const value_164: TAppThirdPartyId = TAppThirdPartyId.read(input);
                            value_163.push(value_164);
                        }
                        input.readListEnd();
                        _args.otherThirdPartyIds = value_163;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 24:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_165: Array<TAppProfessionalInfo> = new Array<TAppProfessionalInfo>();
                        const metadata_28: thrift.TList = input.readListBegin();
                        const size_28: number = metadata_28.size;
                        for (let i_28: number = 0; i_28 < size_28; i_28++) {
                            const value_166: TAppProfessionalInfo = TAppProfessionalInfo.read(input);
                            value_165.push(value_166);
                        }
                        input.readListEnd();
                        _args.otherProfessionalInfos = value_165;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 20:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_167: boolean = input.readBool();
                        _args.archived = value_167;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 21:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_168: boolean = input.readBool();
                        _args.improved = value_168;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 26:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_169: Array<TAppContactId> = new Array<TAppContactId>();
                        const metadata_29: thrift.TList = input.readListBegin();
                        const size_29: number = metadata_29.size;
                        for (let i_29: number = 0; i_29 < size_29; i_29++) {
                            const value_170: TAppContactId = TAppContactId.read(input);
                            value_169.push(value_170);
                        }
                        input.readListEnd();
                        _args.originalContactIds = value_169;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 23:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_171: Int64 = input.readI64();
                        _args.editSequenceId = value_171;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 27:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_172: string = input.readString();
                        _args.contactUserId = value_172;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 28:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_173: TAppEmailMessage = TAppEmailMessage.read(input);
                        _args.contextEmail = value_173;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 29:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_174: TAppContactContext = TAppContactContext.read(input);
                        _args.context = value_174;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 30:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_175: string = input.readString();
                        _args.serverEditSeqId = value_175;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 31:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_176: boolean = input.readBool();
                        _args.hasNotes = value_176;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 33:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_177: Set<TAppProvenance> = new Set<TAppProvenance>();
                        const metadata_30: thrift.TSet = input.readSetBegin();
                        const size_30: number = metadata_30.size;
                        for (let i_30: number = 0; i_30 < size_30; i_30++) {
                            const value_178: TAppProvenance = input.readI32();
                            value_177.add(value_178);
                        }
                        input.readSetEnd();
                        _args.provenances = value_177;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 34:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_179: Array<TAppBirthdayPreference> = new Array<TAppBirthdayPreference>();
                        const metadata_31: thrift.TList = input.readListBegin();
                        const size_31: number = metadata_31.size;
                        for (let i_31: number = 0; i_31 < size_31; i_31++) {
                            const value_180: TAppBirthdayPreference = input.readI32();
                            value_179.push(value_180);
                        }
                        input.readListEnd();
                        _args.birthdayPreferences = value_179;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 35:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_181: PAppNotifications.TAppNotificationPreferenceMode = input.readI32();
                        _args.notificationMode = value_181;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 36:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_182: TAppContactType = input.readI32();
                        _args.contactType = value_182;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 37:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_183: TAppContactMetadata = TAppContactMetadata.read(input);
                        _args.contactMetadata = value_183;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 38:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_184: TAppRelation = TAppRelation.read(input);
                        _args.relation = value_184;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppContact(_args);
    }
}
export enum TAppProduct {
    MOUSE,
    HELIOS
}
export interface ITUserAgentArgs {
    platform?: string;
    version?: string;
    deviceVersion?: string;
    osVersion?: string;
    product?: TAppProduct;
}
export class TUserAgent {
    public platform?: string;
    public version?: string;
    public deviceVersion?: string;
    public osVersion?: string;
    public product?: TAppProduct;
    constructor(args?: ITUserAgentArgs) {
        if (args != null && args.platform != null) {
            this.platform = args.platform;
        }
        if (args != null && args.version != null) {
            this.version = args.version;
        }
        if (args != null && args.deviceVersion != null) {
            this.deviceVersion = args.deviceVersion;
        }
        if (args != null && args.osVersion != null) {
            this.osVersion = args.osVersion;
        }
        if (args != null && args.product != null) {
            this.product = args.product;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUserAgent");
        if (this.platform != null) {
            output.writeFieldBegin("platform", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.platform);
            output.writeFieldEnd();
        }
        if (this.version != null) {
            output.writeFieldBegin("version", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.version);
            output.writeFieldEnd();
        }
        if (this.deviceVersion != null) {
            output.writeFieldBegin("deviceVersion", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.deviceVersion);
            output.writeFieldEnd();
        }
        if (this.osVersion != null) {
            output.writeFieldBegin("osVersion", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.osVersion);
            output.writeFieldEnd();
        }
        if (this.product != null) {
            output.writeFieldBegin("product", thrift.Thrift.Type.I32, 5);
            output.writeI32(this.product);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUserAgent {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_185: string = input.readString();
                        _args.platform = value_185;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_186: string = input.readString();
                        _args.version = value_186;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_187: string = input.readString();
                        _args.deviceVersion = value_187;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_188: string = input.readString();
                        _args.osVersion = value_188;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_189: TAppProduct = input.readI32();
                        _args.product = value_189;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUserAgent(_args);
    }
}
export interface ITAuthHeaderArgs {
    userId: string;
    deviceId: string;
    accessToken: string;
    timestamp: number | Int64;
    agent?: TUserAgent;
}
export class TAuthHeader {
    public userId: string;
    public deviceId: string;
    public accessToken: string;
    public timestamp: Int64;
    public agent?: TUserAgent;
    constructor(args: ITAuthHeaderArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.deviceId != null) {
            this.deviceId = args.deviceId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[deviceId] is unset!");
        }
        if (args != null && args.accessToken != null) {
            this.accessToken = args.accessToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[accessToken] is unset!");
        }
        if (args != null && args.timestamp != null) {
            if (typeof args.timestamp === "number") {
                this.timestamp = new Int64(args.timestamp);
            }
            else {
                this.timestamp = args.timestamp;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[timestamp] is unset!");
        }
        if (args != null && args.agent != null) {
            this.agent = args.agent;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAuthHeader");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.deviceId != null) {
            output.writeFieldBegin("deviceId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.deviceId);
            output.writeFieldEnd();
        }
        if (this.accessToken != null) {
            output.writeFieldBegin("accessToken", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.accessToken);
            output.writeFieldEnd();
        }
        if (this.timestamp != null) {
            output.writeFieldBegin("timestamp", thrift.Thrift.Type.I64, 4);
            output.writeI64(this.timestamp);
            output.writeFieldEnd();
        }
        if (this.agent != null) {
            output.writeFieldBegin("agent", thrift.Thrift.Type.STRUCT, 5);
            this.agent.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAuthHeader {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_190: string = input.readString();
                        _args.userId = value_190;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_191: string = input.readString();
                        _args.deviceId = value_191;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_192: string = input.readString();
                        _args.accessToken = value_192;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_193: Int64 = input.readI64();
                        _args.timestamp = value_193;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_194: TUserAgent = TUserAgent.read(input);
                        _args.agent = value_194;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.deviceId !== undefined && _args.accessToken !== undefined && _args.timestamp !== undefined) {
            return new TAuthHeader(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAuthHeader from input");
        }
    }
}
export interface ITWebAuthHeaderArgs {
    userId: string;
    accessToken: string;
    timestamp: number | Int64;
}
export class TWebAuthHeader {
    public userId: string;
    public accessToken: string;
    public timestamp: Int64;
    constructor(args: ITWebAuthHeaderArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.accessToken != null) {
            this.accessToken = args.accessToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[accessToken] is unset!");
        }
        if (args != null && args.timestamp != null) {
            if (typeof args.timestamp === "number") {
                this.timestamp = new Int64(args.timestamp);
            }
            else {
                this.timestamp = args.timestamp;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[timestamp] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TWebAuthHeader");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.accessToken != null) {
            output.writeFieldBegin("accessToken", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.accessToken);
            output.writeFieldEnd();
        }
        if (this.timestamp != null) {
            output.writeFieldBegin("timestamp", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.timestamp);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TWebAuthHeader {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_195: string = input.readString();
                        _args.userId = value_195;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_196: string = input.readString();
                        _args.accessToken = value_196;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_197: Int64 = input.readI64();
                        _args.timestamp = value_197;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.accessToken !== undefined && _args.timestamp !== undefined) {
            return new TWebAuthHeader(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TWebAuthHeader from input");
        }
    }
}
export interface ITHeliosOrderDashBoardHeaderArgs {
    heliosAuthToken: string;
    userId?: string;
    timestamp?: number | Int64;
}
export class THeliosOrderDashBoardHeader {
    public heliosAuthToken: string;
    public userId?: string;
    public timestamp?: Int64;
    constructor(args: ITHeliosOrderDashBoardHeaderArgs) {
        if (args != null && args.heliosAuthToken != null) {
            this.heliosAuthToken = args.heliosAuthToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[heliosAuthToken] is unset!");
        }
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        if (args != null && args.timestamp != null) {
            if (typeof args.timestamp === "number") {
                this.timestamp = new Int64(args.timestamp);
            }
            else {
                this.timestamp = args.timestamp;
            }
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("THeliosOrderDashBoardHeader");
        if (this.heliosAuthToken != null) {
            output.writeFieldBegin("heliosAuthToken", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.heliosAuthToken);
            output.writeFieldEnd();
        }
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.timestamp != null) {
            output.writeFieldBegin("timestamp", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.timestamp);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): THeliosOrderDashBoardHeader {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_198: string = input.readString();
                        _args.heliosAuthToken = value_198;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_199: string = input.readString();
                        _args.userId = value_199;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_200: Int64 = input.readI64();
                        _args.timestamp = value_200;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.heliosAuthToken !== undefined) {
            return new THeliosOrderDashBoardHeader(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read THeliosOrderDashBoardHeader from input");
        }
    }
}
export enum TAppOAuthProvider {
    UNDEFINED = 0,
    GOOGLE = 1,
    FACEBOOK_BIRTHDAYS = 2
}
export interface ITAppColocationArgs {
    address?: PContact.TAppAddress;
    timestampSec?: number | Int64;
}
export class TAppColocation {
    public address?: PContact.TAppAddress;
    public timestampSec?: Int64;
    constructor(args?: ITAppColocationArgs) {
        if (args != null && args.address != null) {
            this.address = args.address;
        }
        if (args != null && args.timestampSec != null) {
            if (typeof args.timestampSec === "number") {
                this.timestampSec = new Int64(args.timestampSec);
            }
            else {
                this.timestampSec = args.timestampSec;
            }
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppColocation");
        if (this.address != null) {
            output.writeFieldBegin("address", thrift.Thrift.Type.STRUCT, 1);
            this.address.write(output);
            output.writeFieldEnd();
        }
        if (this.timestampSec != null) {
            output.writeFieldBegin("timestampSec", thrift.Thrift.Type.I64, 2);
            output.writeI64(this.timestampSec);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppColocation {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_201: PContact.TAppAddress = PContact.TAppAddress.read(input);
                        _args.address = value_201;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_202: Int64 = input.readI64();
                        _args.timestampSec = value_202;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppColocation(_args);
    }
}
export enum TAppDayOfWeek {
    UNDEFINED = 0,
    SUNDAY = 1,
    MONDAY = 2,
    TUESDAY = 3,
    WEDNESDAY = 4,
    THURSDAY = 5,
    FRIDAY = 6,
    SATURDAY = 7
}
export interface ITAppDayTimeArgs {
    dayOfWeek?: TAppDayOfWeek;
    hour?: number;
    minute?: number;
}
export class TAppDayTime {
    public dayOfWeek?: TAppDayOfWeek;
    public hour?: number;
    public minute?: number;
    constructor(args?: ITAppDayTimeArgs) {
        if (args != null && args.dayOfWeek != null) {
            this.dayOfWeek = args.dayOfWeek;
        }
        if (args != null && args.hour != null) {
            this.hour = args.hour;
        }
        if (args != null && args.minute != null) {
            this.minute = args.minute;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppDayTime");
        if (this.dayOfWeek != null) {
            output.writeFieldBegin("dayOfWeek", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.dayOfWeek);
            output.writeFieldEnd();
        }
        if (this.hour != null) {
            output.writeFieldBegin("hour", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.hour);
            output.writeFieldEnd();
        }
        if (this.minute != null) {
            output.writeFieldBegin("minute", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.minute);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppDayTime {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_203: TAppDayOfWeek = input.readI32();
                        _args.dayOfWeek = value_203;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_204: number = input.readI32();
                        _args.hour = value_204;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_205: number = input.readI32();
                        _args.minute = value_205;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppDayTime(_args);
    }
}
export enum TAppDeeplinkType {
    UNDEFINED = 0,
    SHARE_CONTACT = 1,
    SHARE_SHADOW_CONTACT = 2,
    CREATE_CONTACT = 3,
    CONNECT = 4,
    GOOGLE_AUTH = 5,
    FOR_YOU = 6,
    WALKAWAY_CONNECT = 7,
    BACKGROUND_LOCATION_FETCH = 8,
    WEB_APP_AUTH = 9,
    FB_IMPORT_AUTH = 10,
    SCHEDULED_MESSAGE = 11,
    INVOICE_SENT = 12,
    HOMEPAGE_REVERSE_INDEX = 13,
    HOMEPAGE_MERGE_SUGGESTION = 14,
    HOMEPAGE_NAME_SUGGESTION = 15,
    HOMEPAGE_NAME_COMPLETION = 16,
    EXPORT_ERROR = 17,
    EXPORT_COMPLETE = 18,
    EXPORT_READY = 19,
    HELIOS_EMAIL_REMINDERS = 20
}
export enum TAppEKEventStatus {
    NONE,
    CONFIRMED,
    TENTATIVE,
    CANCELED
}
export enum TAppEKParticipantStatus {
    UNKNOWN,
    PENDING,
    ACCEPTED,
    DECLINED,
    TENTATIVE,
    DELEGATED,
    COMPLETED,
    IN_PROCESS
}
export enum TAppEKParticipantRole {
    UNKNOWN,
    REQUIRED,
    OPTIONAL,
    CHAIR,
    NON_PARTICIPANT
}
export enum TAppEKParticipantType {
    UNKNOWN,
    PERSON,
    ROOM,
    RESOURCE,
    GROUP
}
export enum TAppEKEventAvailability {
    NOT_SUPPORTED,
    BUSY,
    FREE,
    TENTATIVE,
    UNAVAILABLE
}
export enum TAppEKCalendarType {
    LOCAL,
    CAL_DAV,
    EXCHANGE,
    SUBSCRIPTION,
    BIRTHDAY
}
export enum TAppEKSourceType {
    LOCAL,
    EXCHANGE,
    CAL_DAV,
    MOBILE_ME,
    SUBSCRIBED,
    BIRTHDAYS
}
export enum TAppEKSpan {
    THIS_EVENT,
    FUTURE_EVENTS
}
export enum TAppEKRecurrenceFrequency {
    DAILY,
    WEEKLY,
    MONTHLY,
    YEARLY
}
export enum TAppEKWeekday {
    SUNDAY,
    MONDAY,
    TUESDAY,
    WEDNESDAY,
    THURSDAY,
    FRIDAY,
    SATURDAY
}
export enum TAppEKCalendarEventAvailabilityMaskItem {
    BUSY,
    FREE,
    TENTATIVE,
    UNAVAILABLE
}
export enum TAppEKEntityMaskItem {
    EVENT,
    REMINDER
}
export enum TAppEKAlarmProximity {
    NONE,
    ENTER,
    LEAVE
}
export enum TAppEKAlarmType {
    DISPLAY,
    AUDIO,
    PROCEDURE,
    EMAIL
}
export interface ITAppEKEventArgs {
    eventIdentifier?: string;
    calendar?: TAppEKCalendar;
    calendarItemIdentifier?: string;
    calendarItemExternalIdentifier?: string;
    title?: string;
    location?: string;
    notes?: string;
    url?: string;
    lastModifiedDate?: number | Int64;
    creationDate?: number | Int64;
    timezoneString?: string;
    hasAlarms?: boolean;
    hasReccurrenceRules?: boolean;
    hasAttendees?: boolean;
    hasNotes?: boolean;
    attendees?: Array<TAppEKParticipant>;
    alarms?: Array<TAppEKAlarm>;
    recurrenceRules?: Array<TAppEKRecurrenceRule>;
    isAllDay?: boolean;
    startDate?: number | Int64;
    endDate?: number | Int64;
    structuredLocation?: TAppEKStructuredLocation;
    organizer?: TAppEKParticipant;
    availability?: TAppEKEventAvailability;
    status?: TAppEKEventStatus;
    isDetached?: boolean;
    occurenceDate?: number | Int64;
    birthdayContactIdentifier?: string;
}
export class TAppEKEvent {
    public eventIdentifier?: string;
    public calendar?: TAppEKCalendar;
    public calendarItemIdentifier?: string;
    public calendarItemExternalIdentifier?: string;
    public title?: string;
    public location?: string;
    public notes?: string;
    public url?: string;
    public lastModifiedDate?: Int64;
    public creationDate?: Int64;
    public timezoneString?: string;
    public hasAlarms?: boolean;
    public hasReccurrenceRules?: boolean;
    public hasAttendees?: boolean;
    public hasNotes?: boolean;
    public attendees?: Array<TAppEKParticipant>;
    public alarms?: Array<TAppEKAlarm>;
    public recurrenceRules?: Array<TAppEKRecurrenceRule>;
    public isAllDay?: boolean;
    public startDate?: Int64;
    public endDate?: Int64;
    public structuredLocation?: TAppEKStructuredLocation;
    public organizer?: TAppEKParticipant;
    public availability?: TAppEKEventAvailability;
    public status?: TAppEKEventStatus;
    public isDetached?: boolean;
    public occurenceDate?: Int64;
    public birthdayContactIdentifier?: string;
    constructor(args?: ITAppEKEventArgs) {
        if (args != null && args.eventIdentifier != null) {
            this.eventIdentifier = args.eventIdentifier;
        }
        if (args != null && args.calendar != null) {
            this.calendar = args.calendar;
        }
        if (args != null && args.calendarItemIdentifier != null) {
            this.calendarItemIdentifier = args.calendarItemIdentifier;
        }
        if (args != null && args.calendarItemExternalIdentifier != null) {
            this.calendarItemExternalIdentifier = args.calendarItemExternalIdentifier;
        }
        if (args != null && args.title != null) {
            this.title = args.title;
        }
        if (args != null && args.location != null) {
            this.location = args.location;
        }
        if (args != null && args.notes != null) {
            this.notes = args.notes;
        }
        if (args != null && args.url != null) {
            this.url = args.url;
        }
        if (args != null && args.lastModifiedDate != null) {
            if (typeof args.lastModifiedDate === "number") {
                this.lastModifiedDate = new Int64(args.lastModifiedDate);
            }
            else {
                this.lastModifiedDate = args.lastModifiedDate;
            }
        }
        if (args != null && args.creationDate != null) {
            if (typeof args.creationDate === "number") {
                this.creationDate = new Int64(args.creationDate);
            }
            else {
                this.creationDate = args.creationDate;
            }
        }
        if (args != null && args.timezoneString != null) {
            this.timezoneString = args.timezoneString;
        }
        if (args != null && args.hasAlarms != null) {
            this.hasAlarms = args.hasAlarms;
        }
        if (args != null && args.hasReccurrenceRules != null) {
            this.hasReccurrenceRules = args.hasReccurrenceRules;
        }
        if (args != null && args.hasAttendees != null) {
            this.hasAttendees = args.hasAttendees;
        }
        if (args != null && args.hasNotes != null) {
            this.hasNotes = args.hasNotes;
        }
        if (args != null && args.attendees != null) {
            this.attendees = args.attendees;
        }
        if (args != null && args.alarms != null) {
            this.alarms = args.alarms;
        }
        if (args != null && args.recurrenceRules != null) {
            this.recurrenceRules = args.recurrenceRules;
        }
        if (args != null && args.isAllDay != null) {
            this.isAllDay = args.isAllDay;
        }
        if (args != null && args.startDate != null) {
            if (typeof args.startDate === "number") {
                this.startDate = new Int64(args.startDate);
            }
            else {
                this.startDate = args.startDate;
            }
        }
        if (args != null && args.endDate != null) {
            if (typeof args.endDate === "number") {
                this.endDate = new Int64(args.endDate);
            }
            else {
                this.endDate = args.endDate;
            }
        }
        if (args != null && args.structuredLocation != null) {
            this.structuredLocation = args.structuredLocation;
        }
        if (args != null && args.organizer != null) {
            this.organizer = args.organizer;
        }
        if (args != null && args.availability != null) {
            this.availability = args.availability;
        }
        if (args != null && args.status != null) {
            this.status = args.status;
        }
        if (args != null && args.isDetached != null) {
            this.isDetached = args.isDetached;
        }
        if (args != null && args.occurenceDate != null) {
            if (typeof args.occurenceDate === "number") {
                this.occurenceDate = new Int64(args.occurenceDate);
            }
            else {
                this.occurenceDate = args.occurenceDate;
            }
        }
        if (args != null && args.birthdayContactIdentifier != null) {
            this.birthdayContactIdentifier = args.birthdayContactIdentifier;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEKEvent");
        if (this.eventIdentifier != null) {
            output.writeFieldBegin("eventIdentifier", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.eventIdentifier);
            output.writeFieldEnd();
        }
        if (this.calendar != null) {
            output.writeFieldBegin("calendar", thrift.Thrift.Type.STRUCT, 2);
            this.calendar.write(output);
            output.writeFieldEnd();
        }
        if (this.calendarItemIdentifier != null) {
            output.writeFieldBegin("calendarItemIdentifier", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.calendarItemIdentifier);
            output.writeFieldEnd();
        }
        if (this.calendarItemExternalIdentifier != null) {
            output.writeFieldBegin("calendarItemExternalIdentifier", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.calendarItemExternalIdentifier);
            output.writeFieldEnd();
        }
        if (this.title != null) {
            output.writeFieldBegin("title", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.title);
            output.writeFieldEnd();
        }
        if (this.location != null) {
            output.writeFieldBegin("location", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.location);
            output.writeFieldEnd();
        }
        if (this.notes != null) {
            output.writeFieldBegin("notes", thrift.Thrift.Type.STRING, 7);
            output.writeString(this.notes);
            output.writeFieldEnd();
        }
        if (this.url != null) {
            output.writeFieldBegin("url", thrift.Thrift.Type.STRING, 8);
            output.writeString(this.url);
            output.writeFieldEnd();
        }
        if (this.lastModifiedDate != null) {
            output.writeFieldBegin("lastModifiedDate", thrift.Thrift.Type.I64, 9);
            output.writeI64(this.lastModifiedDate);
            output.writeFieldEnd();
        }
        if (this.creationDate != null) {
            output.writeFieldBegin("creationDate", thrift.Thrift.Type.I64, 10);
            output.writeI64(this.creationDate);
            output.writeFieldEnd();
        }
        if (this.timezoneString != null) {
            output.writeFieldBegin("timezoneString", thrift.Thrift.Type.STRING, 11);
            output.writeString(this.timezoneString);
            output.writeFieldEnd();
        }
        if (this.hasAlarms != null) {
            output.writeFieldBegin("hasAlarms", thrift.Thrift.Type.BOOL, 12);
            output.writeBool(this.hasAlarms);
            output.writeFieldEnd();
        }
        if (this.hasReccurrenceRules != null) {
            output.writeFieldBegin("hasReccurrenceRules", thrift.Thrift.Type.BOOL, 13);
            output.writeBool(this.hasReccurrenceRules);
            output.writeFieldEnd();
        }
        if (this.hasAttendees != null) {
            output.writeFieldBegin("hasAttendees", thrift.Thrift.Type.BOOL, 14);
            output.writeBool(this.hasAttendees);
            output.writeFieldEnd();
        }
        if (this.hasNotes != null) {
            output.writeFieldBegin("hasNotes", thrift.Thrift.Type.BOOL, 15);
            output.writeBool(this.hasNotes);
            output.writeFieldEnd();
        }
        if (this.attendees != null) {
            output.writeFieldBegin("attendees", thrift.Thrift.Type.LIST, 16);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.attendees.length);
            this.attendees.forEach((value_206: TAppEKParticipant): void => {
                value_206.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.alarms != null) {
            output.writeFieldBegin("alarms", thrift.Thrift.Type.LIST, 17);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.alarms.length);
            this.alarms.forEach((value_207: TAppEKAlarm): void => {
                value_207.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.recurrenceRules != null) {
            output.writeFieldBegin("recurrenceRules", thrift.Thrift.Type.LIST, 18);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.recurrenceRules.length);
            this.recurrenceRules.forEach((value_208: TAppEKRecurrenceRule): void => {
                value_208.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.isAllDay != null) {
            output.writeFieldBegin("isAllDay", thrift.Thrift.Type.BOOL, 19);
            output.writeBool(this.isAllDay);
            output.writeFieldEnd();
        }
        if (this.startDate != null) {
            output.writeFieldBegin("startDate", thrift.Thrift.Type.I64, 20);
            output.writeI64(this.startDate);
            output.writeFieldEnd();
        }
        if (this.endDate != null) {
            output.writeFieldBegin("endDate", thrift.Thrift.Type.I64, 21);
            output.writeI64(this.endDate);
            output.writeFieldEnd();
        }
        if (this.structuredLocation != null) {
            output.writeFieldBegin("structuredLocation", thrift.Thrift.Type.STRUCT, 22);
            this.structuredLocation.write(output);
            output.writeFieldEnd();
        }
        if (this.organizer != null) {
            output.writeFieldBegin("organizer", thrift.Thrift.Type.STRUCT, 23);
            this.organizer.write(output);
            output.writeFieldEnd();
        }
        if (this.availability != null) {
            output.writeFieldBegin("availability", thrift.Thrift.Type.I32, 24);
            output.writeI32(this.availability);
            output.writeFieldEnd();
        }
        if (this.status != null) {
            output.writeFieldBegin("status", thrift.Thrift.Type.I32, 25);
            output.writeI32(this.status);
            output.writeFieldEnd();
        }
        if (this.isDetached != null) {
            output.writeFieldBegin("isDetached", thrift.Thrift.Type.BOOL, 26);
            output.writeBool(this.isDetached);
            output.writeFieldEnd();
        }
        if (this.occurenceDate != null) {
            output.writeFieldBegin("occurenceDate", thrift.Thrift.Type.I64, 27);
            output.writeI64(this.occurenceDate);
            output.writeFieldEnd();
        }
        if (this.birthdayContactIdentifier != null) {
            output.writeFieldBegin("birthdayContactIdentifier", thrift.Thrift.Type.STRING, 28);
            output.writeString(this.birthdayContactIdentifier);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEKEvent {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_209: string = input.readString();
                        _args.eventIdentifier = value_209;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_210: TAppEKCalendar = TAppEKCalendar.read(input);
                        _args.calendar = value_210;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_211: string = input.readString();
                        _args.calendarItemIdentifier = value_211;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_212: string = input.readString();
                        _args.calendarItemExternalIdentifier = value_212;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_213: string = input.readString();
                        _args.title = value_213;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_214: string = input.readString();
                        _args.location = value_214;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_215: string = input.readString();
                        _args.notes = value_215;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_216: string = input.readString();
                        _args.url = value_216;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_217: Int64 = input.readI64();
                        _args.lastModifiedDate = value_217;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_218: Int64 = input.readI64();
                        _args.creationDate = value_218;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_219: string = input.readString();
                        _args.timezoneString = value_219;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_220: boolean = input.readBool();
                        _args.hasAlarms = value_220;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 13:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_221: boolean = input.readBool();
                        _args.hasReccurrenceRules = value_221;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 14:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_222: boolean = input.readBool();
                        _args.hasAttendees = value_222;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 15:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_223: boolean = input.readBool();
                        _args.hasNotes = value_223;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 16:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_224: Array<TAppEKParticipant> = new Array<TAppEKParticipant>();
                        const metadata_32: thrift.TList = input.readListBegin();
                        const size_32: number = metadata_32.size;
                        for (let i_32: number = 0; i_32 < size_32; i_32++) {
                            const value_225: TAppEKParticipant = TAppEKParticipant.read(input);
                            value_224.push(value_225);
                        }
                        input.readListEnd();
                        _args.attendees = value_224;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 17:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_226: Array<TAppEKAlarm> = new Array<TAppEKAlarm>();
                        const metadata_33: thrift.TList = input.readListBegin();
                        const size_33: number = metadata_33.size;
                        for (let i_33: number = 0; i_33 < size_33; i_33++) {
                            const value_227: TAppEKAlarm = TAppEKAlarm.read(input);
                            value_226.push(value_227);
                        }
                        input.readListEnd();
                        _args.alarms = value_226;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 18:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_228: Array<TAppEKRecurrenceRule> = new Array<TAppEKRecurrenceRule>();
                        const metadata_34: thrift.TList = input.readListBegin();
                        const size_34: number = metadata_34.size;
                        for (let i_34: number = 0; i_34 < size_34; i_34++) {
                            const value_229: TAppEKRecurrenceRule = TAppEKRecurrenceRule.read(input);
                            value_228.push(value_229);
                        }
                        input.readListEnd();
                        _args.recurrenceRules = value_228;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 19:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_230: boolean = input.readBool();
                        _args.isAllDay = value_230;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 20:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_231: Int64 = input.readI64();
                        _args.startDate = value_231;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 21:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_232: Int64 = input.readI64();
                        _args.endDate = value_232;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 22:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_233: TAppEKStructuredLocation = TAppEKStructuredLocation.read(input);
                        _args.structuredLocation = value_233;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 23:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_234: TAppEKParticipant = TAppEKParticipant.read(input);
                        _args.organizer = value_234;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 24:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_235: TAppEKEventAvailability = input.readI32();
                        _args.availability = value_235;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 25:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_236: TAppEKEventStatus = input.readI32();
                        _args.status = value_236;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 26:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_237: boolean = input.readBool();
                        _args.isDetached = value_237;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 27:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_238: Int64 = input.readI64();
                        _args.occurenceDate = value_238;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 28:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_239: string = input.readString();
                        _args.birthdayContactIdentifier = value_239;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppEKEvent(_args);
    }
}
export interface ITAppEKCalendarArgs {
    source?: TAppEKSource;
    calendarIdentifier: string;
    title?: string;
    type?: TAppEKCalendarType;
    allowsContentModifications?: boolean;
    isSubscribed?: boolean;
    isImmutable?: boolean;
    supportedEventAvailabilities?: Set<TAppEKCalendarEventAvailabilityMaskItem>;
    allowedEntityTypes?: Set<TAppEKEntityMaskItem>;
}
export class TAppEKCalendar {
    public source?: TAppEKSource;
    public calendarIdentifier: string;
    public title?: string;
    public type?: TAppEKCalendarType;
    public allowsContentModifications?: boolean;
    public isSubscribed?: boolean;
    public isImmutable?: boolean;
    public supportedEventAvailabilities?: Set<TAppEKCalendarEventAvailabilityMaskItem>;
    public allowedEntityTypes?: Set<TAppEKEntityMaskItem>;
    constructor(args: ITAppEKCalendarArgs) {
        if (args != null && args.source != null) {
            this.source = args.source;
        }
        if (args != null && args.calendarIdentifier != null) {
            this.calendarIdentifier = args.calendarIdentifier;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[calendarIdentifier] is unset!");
        }
        if (args != null && args.title != null) {
            this.title = args.title;
        }
        if (args != null && args.type != null) {
            this.type = args.type;
        }
        if (args != null && args.allowsContentModifications != null) {
            this.allowsContentModifications = args.allowsContentModifications;
        }
        if (args != null && args.isSubscribed != null) {
            this.isSubscribed = args.isSubscribed;
        }
        if (args != null && args.isImmutable != null) {
            this.isImmutable = args.isImmutable;
        }
        if (args != null && args.supportedEventAvailabilities != null) {
            this.supportedEventAvailabilities = args.supportedEventAvailabilities;
        }
        if (args != null && args.allowedEntityTypes != null) {
            this.allowedEntityTypes = args.allowedEntityTypes;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEKCalendar");
        if (this.source != null) {
            output.writeFieldBegin("source", thrift.Thrift.Type.STRUCT, 1);
            this.source.write(output);
            output.writeFieldEnd();
        }
        if (this.calendarIdentifier != null) {
            output.writeFieldBegin("calendarIdentifier", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.calendarIdentifier);
            output.writeFieldEnd();
        }
        if (this.title != null) {
            output.writeFieldBegin("title", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.title);
            output.writeFieldEnd();
        }
        if (this.type != null) {
            output.writeFieldBegin("type", thrift.Thrift.Type.I32, 4);
            output.writeI32(this.type);
            output.writeFieldEnd();
        }
        if (this.allowsContentModifications != null) {
            output.writeFieldBegin("allowsContentModifications", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.allowsContentModifications);
            output.writeFieldEnd();
        }
        if (this.isSubscribed != null) {
            output.writeFieldBegin("isSubscribed", thrift.Thrift.Type.BOOL, 6);
            output.writeBool(this.isSubscribed);
            output.writeFieldEnd();
        }
        if (this.isImmutable != null) {
            output.writeFieldBegin("isImmutable", thrift.Thrift.Type.BOOL, 7);
            output.writeBool(this.isImmutable);
            output.writeFieldEnd();
        }
        if (this.supportedEventAvailabilities != null) {
            output.writeFieldBegin("supportedEventAvailabilities", thrift.Thrift.Type.SET, 8);
            output.writeSetBegin(thrift.Thrift.Type.I32, this.supportedEventAvailabilities.size);
            this.supportedEventAvailabilities.forEach((value_240: TAppEKCalendarEventAvailabilityMaskItem): void => {
                output.writeI32(value_240);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        if (this.allowedEntityTypes != null) {
            output.writeFieldBegin("allowedEntityTypes", thrift.Thrift.Type.SET, 9);
            output.writeSetBegin(thrift.Thrift.Type.I32, this.allowedEntityTypes.size);
            this.allowedEntityTypes.forEach((value_241: TAppEKEntityMaskItem): void => {
                output.writeI32(value_241);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEKCalendar {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_242: TAppEKSource = TAppEKSource.read(input);
                        _args.source = value_242;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_243: string = input.readString();
                        _args.calendarIdentifier = value_243;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_244: string = input.readString();
                        _args.title = value_244;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_245: TAppEKCalendarType = input.readI32();
                        _args.type = value_245;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_246: boolean = input.readBool();
                        _args.allowsContentModifications = value_246;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_247: boolean = input.readBool();
                        _args.isSubscribed = value_247;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_248: boolean = input.readBool();
                        _args.isImmutable = value_248;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_249: Set<TAppEKCalendarEventAvailabilityMaskItem> = new Set<TAppEKCalendarEventAvailabilityMaskItem>();
                        const metadata_35: thrift.TSet = input.readSetBegin();
                        const size_35: number = metadata_35.size;
                        for (let i_35: number = 0; i_35 < size_35; i_35++) {
                            const value_250: TAppEKCalendarEventAvailabilityMaskItem = input.readI32();
                            value_249.add(value_250);
                        }
                        input.readSetEnd();
                        _args.supportedEventAvailabilities = value_249;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_251: Set<TAppEKEntityMaskItem> = new Set<TAppEKEntityMaskItem>();
                        const metadata_36: thrift.TSet = input.readSetBegin();
                        const size_36: number = metadata_36.size;
                        for (let i_36: number = 0; i_36 < size_36; i_36++) {
                            const value_252: TAppEKEntityMaskItem = input.readI32();
                            value_251.add(value_252);
                        }
                        input.readSetEnd();
                        _args.allowedEntityTypes = value_251;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.calendarIdentifier !== undefined) {
            return new TAppEKCalendar(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppEKCalendar from input");
        }
    }
}
export interface ITAppEKSourceArgs {
    sourceIdentifier?: string;
    sourceType?: TAppEKSourceType;
    title?: string;
}
export class TAppEKSource {
    public sourceIdentifier?: string;
    public sourceType?: TAppEKSourceType;
    public title?: string;
    constructor(args?: ITAppEKSourceArgs) {
        if (args != null && args.sourceIdentifier != null) {
            this.sourceIdentifier = args.sourceIdentifier;
        }
        if (args != null && args.sourceType != null) {
            this.sourceType = args.sourceType;
        }
        if (args != null && args.title != null) {
            this.title = args.title;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEKSource");
        if (this.sourceIdentifier != null) {
            output.writeFieldBegin("sourceIdentifier", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.sourceIdentifier);
            output.writeFieldEnd();
        }
        if (this.sourceType != null) {
            output.writeFieldBegin("sourceType", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.sourceType);
            output.writeFieldEnd();
        }
        if (this.title != null) {
            output.writeFieldBegin("title", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.title);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEKSource {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_253: string = input.readString();
                        _args.sourceIdentifier = value_253;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_254: TAppEKSourceType = input.readI32();
                        _args.sourceType = value_254;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_255: string = input.readString();
                        _args.title = value_255;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppEKSource(_args);
    }
}
export interface ITAppEKParticipantArgs {
    url?: string;
    name?: string;
    participantStatus?: TAppEKParticipantStatus;
    participantRole?: TAppEKParticipantRole;
    participantType?: TAppEKParticipantType;
    isCurrentUser?: boolean;
}
export class TAppEKParticipant {
    public url?: string;
    public name?: string;
    public participantStatus?: TAppEKParticipantStatus;
    public participantRole?: TAppEKParticipantRole;
    public participantType?: TAppEKParticipantType;
    public isCurrentUser?: boolean;
    constructor(args?: ITAppEKParticipantArgs) {
        if (args != null && args.url != null) {
            this.url = args.url;
        }
        if (args != null && args.name != null) {
            this.name = args.name;
        }
        if (args != null && args.participantStatus != null) {
            this.participantStatus = args.participantStatus;
        }
        if (args != null && args.participantRole != null) {
            this.participantRole = args.participantRole;
        }
        if (args != null && args.participantType != null) {
            this.participantType = args.participantType;
        }
        if (args != null && args.isCurrentUser != null) {
            this.isCurrentUser = args.isCurrentUser;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEKParticipant");
        if (this.url != null) {
            output.writeFieldBegin("url", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.url);
            output.writeFieldEnd();
        }
        if (this.name != null) {
            output.writeFieldBegin("name", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.name);
            output.writeFieldEnd();
        }
        if (this.participantStatus != null) {
            output.writeFieldBegin("participantStatus", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.participantStatus);
            output.writeFieldEnd();
        }
        if (this.participantRole != null) {
            output.writeFieldBegin("participantRole", thrift.Thrift.Type.I32, 4);
            output.writeI32(this.participantRole);
            output.writeFieldEnd();
        }
        if (this.participantType != null) {
            output.writeFieldBegin("participantType", thrift.Thrift.Type.I32, 5);
            output.writeI32(this.participantType);
            output.writeFieldEnd();
        }
        if (this.isCurrentUser != null) {
            output.writeFieldBegin("isCurrentUser", thrift.Thrift.Type.BOOL, 6);
            output.writeBool(this.isCurrentUser);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEKParticipant {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_256: string = input.readString();
                        _args.url = value_256;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_257: string = input.readString();
                        _args.name = value_257;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_258: TAppEKParticipantStatus = input.readI32();
                        _args.participantStatus = value_258;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_259: TAppEKParticipantRole = input.readI32();
                        _args.participantRole = value_259;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_260: TAppEKParticipantType = input.readI32();
                        _args.participantType = value_260;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_261: boolean = input.readBool();
                        _args.isCurrentUser = value_261;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppEKParticipant(_args);
    }
}
export interface ITAppEKAlarmArgs {
    absoluteDate?: number | Int64;
    relativeOffset?: number;
    proximity?: TAppEKAlarmProximity;
    structuredLocation?: TAppEKStructuredLocation;
    type?: TAppEKAlarmType;
    emailAddress?: string;
    soundName?: string;
}
export class TAppEKAlarm {
    public absoluteDate?: Int64;
    public relativeOffset?: number;
    public proximity?: TAppEKAlarmProximity;
    public structuredLocation?: TAppEKStructuredLocation;
    public type?: TAppEKAlarmType;
    public emailAddress?: string;
    public soundName?: string;
    constructor(args?: ITAppEKAlarmArgs) {
        if (args != null && args.absoluteDate != null) {
            if (typeof args.absoluteDate === "number") {
                this.absoluteDate = new Int64(args.absoluteDate);
            }
            else {
                this.absoluteDate = args.absoluteDate;
            }
        }
        if (args != null && args.relativeOffset != null) {
            this.relativeOffset = args.relativeOffset;
        }
        if (args != null && args.proximity != null) {
            this.proximity = args.proximity;
        }
        if (args != null && args.structuredLocation != null) {
            this.structuredLocation = args.structuredLocation;
        }
        if (args != null && args.type != null) {
            this.type = args.type;
        }
        if (args != null && args.emailAddress != null) {
            this.emailAddress = args.emailAddress;
        }
        if (args != null && args.soundName != null) {
            this.soundName = args.soundName;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEKAlarm");
        if (this.absoluteDate != null) {
            output.writeFieldBegin("absoluteDate", thrift.Thrift.Type.I64, 1);
            output.writeI64(this.absoluteDate);
            output.writeFieldEnd();
        }
        if (this.relativeOffset != null) {
            output.writeFieldBegin("relativeOffset", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.relativeOffset);
            output.writeFieldEnd();
        }
        if (this.proximity != null) {
            output.writeFieldBegin("proximity", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.proximity);
            output.writeFieldEnd();
        }
        if (this.structuredLocation != null) {
            output.writeFieldBegin("structuredLocation", thrift.Thrift.Type.STRUCT, 4);
            this.structuredLocation.write(output);
            output.writeFieldEnd();
        }
        if (this.type != null) {
            output.writeFieldBegin("type", thrift.Thrift.Type.I32, 5);
            output.writeI32(this.type);
            output.writeFieldEnd();
        }
        if (this.emailAddress != null) {
            output.writeFieldBegin("emailAddress", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.emailAddress);
            output.writeFieldEnd();
        }
        if (this.soundName != null) {
            output.writeFieldBegin("soundName", thrift.Thrift.Type.STRING, 7);
            output.writeString(this.soundName);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEKAlarm {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_262: Int64 = input.readI64();
                        _args.absoluteDate = value_262;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_263: number = input.readI32();
                        _args.relativeOffset = value_263;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_264: TAppEKAlarmProximity = input.readI32();
                        _args.proximity = value_264;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_265: TAppEKStructuredLocation = TAppEKStructuredLocation.read(input);
                        _args.structuredLocation = value_265;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_266: TAppEKAlarmType = input.readI32();
                        _args.type = value_266;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_267: string = input.readString();
                        _args.emailAddress = value_267;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_268: string = input.readString();
                        _args.soundName = value_268;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppEKAlarm(_args);
    }
}
export interface ITAppEKRecurrenceRuleArgs {
    calendarIdentifier?: string;
    recurrenceEnd?: TAppEKRecurrenceEnd;
    frequency?: TAppEKRecurrenceFrequency;
    interval?: number;
    firstDayOfTheWeek?: number;
    daysOfTheWeek?: Array<TAppEKRecurrenceDayOfWeek>;
    daysOfTheMonth?: Array<number>;
    daysOfTheYear?: Array<number>;
    weeksOfTheYear?: Array<number>;
    monthsOfTheYear?: Array<number>;
    setPositions?: Array<number>;
}
export class TAppEKRecurrenceRule {
    public calendarIdentifier?: string;
    public recurrenceEnd?: TAppEKRecurrenceEnd;
    public frequency?: TAppEKRecurrenceFrequency;
    public interval?: number;
    public firstDayOfTheWeek?: number;
    public daysOfTheWeek?: Array<TAppEKRecurrenceDayOfWeek>;
    public daysOfTheMonth?: Array<number>;
    public daysOfTheYear?: Array<number>;
    public weeksOfTheYear?: Array<number>;
    public monthsOfTheYear?: Array<number>;
    public setPositions?: Array<number>;
    constructor(args?: ITAppEKRecurrenceRuleArgs) {
        if (args != null && args.calendarIdentifier != null) {
            this.calendarIdentifier = args.calendarIdentifier;
        }
        if (args != null && args.recurrenceEnd != null) {
            this.recurrenceEnd = args.recurrenceEnd;
        }
        if (args != null && args.frequency != null) {
            this.frequency = args.frequency;
        }
        if (args != null && args.interval != null) {
            this.interval = args.interval;
        }
        if (args != null && args.firstDayOfTheWeek != null) {
            this.firstDayOfTheWeek = args.firstDayOfTheWeek;
        }
        if (args != null && args.daysOfTheWeek != null) {
            this.daysOfTheWeek = args.daysOfTheWeek;
        }
        if (args != null && args.daysOfTheMonth != null) {
            this.daysOfTheMonth = args.daysOfTheMonth;
        }
        if (args != null && args.daysOfTheYear != null) {
            this.daysOfTheYear = args.daysOfTheYear;
        }
        if (args != null && args.weeksOfTheYear != null) {
            this.weeksOfTheYear = args.weeksOfTheYear;
        }
        if (args != null && args.monthsOfTheYear != null) {
            this.monthsOfTheYear = args.monthsOfTheYear;
        }
        if (args != null && args.setPositions != null) {
            this.setPositions = args.setPositions;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEKRecurrenceRule");
        if (this.calendarIdentifier != null) {
            output.writeFieldBegin("calendarIdentifier", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.calendarIdentifier);
            output.writeFieldEnd();
        }
        if (this.recurrenceEnd != null) {
            output.writeFieldBegin("recurrenceEnd", thrift.Thrift.Type.STRUCT, 2);
            this.recurrenceEnd.write(output);
            output.writeFieldEnd();
        }
        if (this.frequency != null) {
            output.writeFieldBegin("frequency", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.frequency);
            output.writeFieldEnd();
        }
        if (this.interval != null) {
            output.writeFieldBegin("interval", thrift.Thrift.Type.I32, 4);
            output.writeI32(this.interval);
            output.writeFieldEnd();
        }
        if (this.firstDayOfTheWeek != null) {
            output.writeFieldBegin("firstDayOfTheWeek", thrift.Thrift.Type.I32, 5);
            output.writeI32(this.firstDayOfTheWeek);
            output.writeFieldEnd();
        }
        if (this.daysOfTheWeek != null) {
            output.writeFieldBegin("daysOfTheWeek", thrift.Thrift.Type.LIST, 6);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.daysOfTheWeek.length);
            this.daysOfTheWeek.forEach((value_269: TAppEKRecurrenceDayOfWeek): void => {
                value_269.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.daysOfTheMonth != null) {
            output.writeFieldBegin("daysOfTheMonth", thrift.Thrift.Type.LIST, 7);
            output.writeListBegin(thrift.Thrift.Type.I32, this.daysOfTheMonth.length);
            this.daysOfTheMonth.forEach((value_270: number): void => {
                output.writeI32(value_270);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.daysOfTheYear != null) {
            output.writeFieldBegin("daysOfTheYear", thrift.Thrift.Type.LIST, 8);
            output.writeListBegin(thrift.Thrift.Type.I32, this.daysOfTheYear.length);
            this.daysOfTheYear.forEach((value_271: number): void => {
                output.writeI32(value_271);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.weeksOfTheYear != null) {
            output.writeFieldBegin("weeksOfTheYear", thrift.Thrift.Type.LIST, 9);
            output.writeListBegin(thrift.Thrift.Type.I32, this.weeksOfTheYear.length);
            this.weeksOfTheYear.forEach((value_272: number): void => {
                output.writeI32(value_272);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.monthsOfTheYear != null) {
            output.writeFieldBegin("monthsOfTheYear", thrift.Thrift.Type.LIST, 10);
            output.writeListBegin(thrift.Thrift.Type.I32, this.monthsOfTheYear.length);
            this.monthsOfTheYear.forEach((value_273: number): void => {
                output.writeI32(value_273);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.setPositions != null) {
            output.writeFieldBegin("setPositions", thrift.Thrift.Type.LIST, 11);
            output.writeListBegin(thrift.Thrift.Type.I32, this.setPositions.length);
            this.setPositions.forEach((value_274: number): void => {
                output.writeI32(value_274);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEKRecurrenceRule {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_275: string = input.readString();
                        _args.calendarIdentifier = value_275;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_276: TAppEKRecurrenceEnd = TAppEKRecurrenceEnd.read(input);
                        _args.recurrenceEnd = value_276;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_277: TAppEKRecurrenceFrequency = input.readI32();
                        _args.frequency = value_277;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_278: number = input.readI32();
                        _args.interval = value_278;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_279: number = input.readI32();
                        _args.firstDayOfTheWeek = value_279;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_280: Array<TAppEKRecurrenceDayOfWeek> = new Array<TAppEKRecurrenceDayOfWeek>();
                        const metadata_37: thrift.TList = input.readListBegin();
                        const size_37: number = metadata_37.size;
                        for (let i_37: number = 0; i_37 < size_37; i_37++) {
                            const value_281: TAppEKRecurrenceDayOfWeek = TAppEKRecurrenceDayOfWeek.read(input);
                            value_280.push(value_281);
                        }
                        input.readListEnd();
                        _args.daysOfTheWeek = value_280;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_282: Array<number> = new Array<number>();
                        const metadata_38: thrift.TList = input.readListBegin();
                        const size_38: number = metadata_38.size;
                        for (let i_38: number = 0; i_38 < size_38; i_38++) {
                            const value_283: number = input.readI32();
                            value_282.push(value_283);
                        }
                        input.readListEnd();
                        _args.daysOfTheMonth = value_282;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_284: Array<number> = new Array<number>();
                        const metadata_39: thrift.TList = input.readListBegin();
                        const size_39: number = metadata_39.size;
                        for (let i_39: number = 0; i_39 < size_39; i_39++) {
                            const value_285: number = input.readI32();
                            value_284.push(value_285);
                        }
                        input.readListEnd();
                        _args.daysOfTheYear = value_284;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_286: Array<number> = new Array<number>();
                        const metadata_40: thrift.TList = input.readListBegin();
                        const size_40: number = metadata_40.size;
                        for (let i_40: number = 0; i_40 < size_40; i_40++) {
                            const value_287: number = input.readI32();
                            value_286.push(value_287);
                        }
                        input.readListEnd();
                        _args.weeksOfTheYear = value_286;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_288: Array<number> = new Array<number>();
                        const metadata_41: thrift.TList = input.readListBegin();
                        const size_41: number = metadata_41.size;
                        for (let i_41: number = 0; i_41 < size_41; i_41++) {
                            const value_289: number = input.readI32();
                            value_288.push(value_289);
                        }
                        input.readListEnd();
                        _args.monthsOfTheYear = value_288;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_290: Array<number> = new Array<number>();
                        const metadata_42: thrift.TList = input.readListBegin();
                        const size_42: number = metadata_42.size;
                        for (let i_42: number = 0; i_42 < size_42; i_42++) {
                            const value_291: number = input.readI32();
                            value_290.push(value_291);
                        }
                        input.readListEnd();
                        _args.setPositions = value_290;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppEKRecurrenceRule(_args);
    }
}
export interface ITAppEKRecurrenceEndArgs {
    endDate?: number | Int64;
    occurrenceCount?: number;
}
export class TAppEKRecurrenceEnd {
    public endDate?: Int64;
    public occurrenceCount?: number;
    constructor(args?: ITAppEKRecurrenceEndArgs) {
        if (args != null && args.endDate != null) {
            if (typeof args.endDate === "number") {
                this.endDate = new Int64(args.endDate);
            }
            else {
                this.endDate = args.endDate;
            }
        }
        if (args != null && args.occurrenceCount != null) {
            this.occurrenceCount = args.occurrenceCount;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEKRecurrenceEnd");
        if (this.endDate != null) {
            output.writeFieldBegin("endDate", thrift.Thrift.Type.I64, 1);
            output.writeI64(this.endDate);
            output.writeFieldEnd();
        }
        if (this.occurrenceCount != null) {
            output.writeFieldBegin("occurrenceCount", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.occurrenceCount);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEKRecurrenceEnd {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_292: Int64 = input.readI64();
                        _args.endDate = value_292;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_293: number = input.readI32();
                        _args.occurrenceCount = value_293;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppEKRecurrenceEnd(_args);
    }
}
export interface ITAppEKRecurrenceDayOfWeekArgs {
    dayOfTheWeek?: TAppEKWeekday;
    weekNumber?: number;
}
export class TAppEKRecurrenceDayOfWeek {
    public dayOfTheWeek?: TAppEKWeekday;
    public weekNumber?: number;
    constructor(args?: ITAppEKRecurrenceDayOfWeekArgs) {
        if (args != null && args.dayOfTheWeek != null) {
            this.dayOfTheWeek = args.dayOfTheWeek;
        }
        if (args != null && args.weekNumber != null) {
            this.weekNumber = args.weekNumber;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEKRecurrenceDayOfWeek");
        if (this.dayOfTheWeek != null) {
            output.writeFieldBegin("dayOfTheWeek", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.dayOfTheWeek);
            output.writeFieldEnd();
        }
        if (this.weekNumber != null) {
            output.writeFieldBegin("weekNumber", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.weekNumber);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEKRecurrenceDayOfWeek {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_294: TAppEKWeekday = input.readI32();
                        _args.dayOfTheWeek = value_294;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_295: number = input.readI32();
                        _args.weekNumber = value_295;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppEKRecurrenceDayOfWeek(_args);
    }
}
export interface ITAppEKStructuredLocationArgs {
    title?: string;
    geolocation?: TAppCLLocation;
    radius?: number;
}
export class TAppEKStructuredLocation {
    public title?: string;
    public geolocation?: TAppCLLocation;
    public radius?: number;
    constructor(args?: ITAppEKStructuredLocationArgs) {
        if (args != null && args.title != null) {
            this.title = args.title;
        }
        if (args != null && args.geolocation != null) {
            this.geolocation = args.geolocation;
        }
        if (args != null && args.radius != null) {
            this.radius = args.radius;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEKStructuredLocation");
        if (this.title != null) {
            output.writeFieldBegin("title", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.title);
            output.writeFieldEnd();
        }
        if (this.geolocation != null) {
            output.writeFieldBegin("geolocation", thrift.Thrift.Type.STRUCT, 2);
            this.geolocation.write(output);
            output.writeFieldEnd();
        }
        if (this.radius != null) {
            output.writeFieldBegin("radius", thrift.Thrift.Type.DOUBLE, 3);
            output.writeDouble(this.radius);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEKStructuredLocation {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_296: string = input.readString();
                        _args.title = value_296;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_297: TAppCLLocation = TAppCLLocation.read(input);
                        _args.geolocation = value_297;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_298: number = input.readDouble();
                        _args.radius = value_298;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppEKStructuredLocation(_args);
    }
}
export interface ITAppCLLocationArgs {
    coordinate?: TAppCLLocationCoordinate2D;
}
export class TAppCLLocation {
    public coordinate?: TAppCLLocationCoordinate2D;
    constructor(args?: ITAppCLLocationArgs) {
        if (args != null && args.coordinate != null) {
            this.coordinate = args.coordinate;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppCLLocation");
        if (this.coordinate != null) {
            output.writeFieldBegin("coordinate", thrift.Thrift.Type.STRUCT, 1);
            this.coordinate.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppCLLocation {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_299: TAppCLLocationCoordinate2D = TAppCLLocationCoordinate2D.read(input);
                        _args.coordinate = value_299;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppCLLocation(_args);
    }
}
export interface ITAppCLLocationCoordinate2DArgs {
    latitude?: number;
    longitude?: number;
}
export class TAppCLLocationCoordinate2D {
    public latitude?: number;
    public longitude?: number;
    constructor(args?: ITAppCLLocationCoordinate2DArgs) {
        if (args != null && args.latitude != null) {
            this.latitude = args.latitude;
        }
        if (args != null && args.longitude != null) {
            this.longitude = args.longitude;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppCLLocationCoordinate2D");
        if (this.latitude != null) {
            output.writeFieldBegin("latitude", thrift.Thrift.Type.DOUBLE, 1);
            output.writeDouble(this.latitude);
            output.writeFieldEnd();
        }
        if (this.longitude != null) {
            output.writeFieldBegin("longitude", thrift.Thrift.Type.DOUBLE, 2);
            output.writeDouble(this.longitude);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppCLLocationCoordinate2D {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_300: number = input.readDouble();
                        _args.latitude = value_300;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_301: number = input.readDouble();
                        _args.longitude = value_301;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppCLLocationCoordinate2D(_args);
    }
}
export enum EmailHeader {
    TO = 0,
    CC = 1,
    BCC = 2,
    FROM = 3
}
export interface ITAppGmailMessageArgs {
    fromEmailAddress?: string;
    toEmailAddresses?: Array<string>;
    ccEmailAddresses?: Array<string>;
    subject?: string;
    timestampSec?: number | Int64;
    messageSnippet?: string;
    gmailDeepLink?: string;
    appleMailDeepLink?: string;
    displayHeaders?: Array<EmailHeader>;
}
export class TAppGmailMessage {
    public fromEmailAddress?: string;
    public toEmailAddresses?: Array<string>;
    public ccEmailAddresses?: Array<string>;
    public subject?: string;
    public timestampSec?: Int64;
    public messageSnippet?: string;
    public gmailDeepLink?: string;
    public appleMailDeepLink?: string;
    public displayHeaders?: Array<EmailHeader>;
    constructor(args?: ITAppGmailMessageArgs) {
        if (args != null && args.fromEmailAddress != null) {
            this.fromEmailAddress = args.fromEmailAddress;
        }
        if (args != null && args.toEmailAddresses != null) {
            this.toEmailAddresses = args.toEmailAddresses;
        }
        if (args != null && args.ccEmailAddresses != null) {
            this.ccEmailAddresses = args.ccEmailAddresses;
        }
        if (args != null && args.subject != null) {
            this.subject = args.subject;
        }
        if (args != null && args.timestampSec != null) {
            if (typeof args.timestampSec === "number") {
                this.timestampSec = new Int64(args.timestampSec);
            }
            else {
                this.timestampSec = args.timestampSec;
            }
        }
        if (args != null && args.messageSnippet != null) {
            this.messageSnippet = args.messageSnippet;
        }
        if (args != null && args.gmailDeepLink != null) {
            this.gmailDeepLink = args.gmailDeepLink;
        }
        if (args != null && args.appleMailDeepLink != null) {
            this.appleMailDeepLink = args.appleMailDeepLink;
        }
        if (args != null && args.displayHeaders != null) {
            this.displayHeaders = args.displayHeaders;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppGmailMessage");
        if (this.fromEmailAddress != null) {
            output.writeFieldBegin("fromEmailAddress", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.fromEmailAddress);
            output.writeFieldEnd();
        }
        if (this.toEmailAddresses != null) {
            output.writeFieldBegin("toEmailAddresses", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.toEmailAddresses.length);
            this.toEmailAddresses.forEach((value_302: string): void => {
                output.writeString(value_302);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.ccEmailAddresses != null) {
            output.writeFieldBegin("ccEmailAddresses", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.ccEmailAddresses.length);
            this.ccEmailAddresses.forEach((value_303: string): void => {
                output.writeString(value_303);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.subject != null) {
            output.writeFieldBegin("subject", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.subject);
            output.writeFieldEnd();
        }
        if (this.timestampSec != null) {
            output.writeFieldBegin("timestampSec", thrift.Thrift.Type.I64, 5);
            output.writeI64(this.timestampSec);
            output.writeFieldEnd();
        }
        if (this.messageSnippet != null) {
            output.writeFieldBegin("messageSnippet", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.messageSnippet);
            output.writeFieldEnd();
        }
        if (this.gmailDeepLink != null) {
            output.writeFieldBegin("gmailDeepLink", thrift.Thrift.Type.STRING, 7);
            output.writeString(this.gmailDeepLink);
            output.writeFieldEnd();
        }
        if (this.appleMailDeepLink != null) {
            output.writeFieldBegin("appleMailDeepLink", thrift.Thrift.Type.STRING, 8);
            output.writeString(this.appleMailDeepLink);
            output.writeFieldEnd();
        }
        if (this.displayHeaders != null) {
            output.writeFieldBegin("displayHeaders", thrift.Thrift.Type.LIST, 9);
            output.writeListBegin(thrift.Thrift.Type.I32, this.displayHeaders.length);
            this.displayHeaders.forEach((value_304: EmailHeader): void => {
                output.writeI32(value_304);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppGmailMessage {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_305: string = input.readString();
                        _args.fromEmailAddress = value_305;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_306: Array<string> = new Array<string>();
                        const metadata_43: thrift.TList = input.readListBegin();
                        const size_43: number = metadata_43.size;
                        for (let i_43: number = 0; i_43 < size_43; i_43++) {
                            const value_307: string = input.readString();
                            value_306.push(value_307);
                        }
                        input.readListEnd();
                        _args.toEmailAddresses = value_306;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_308: Array<string> = new Array<string>();
                        const metadata_44: thrift.TList = input.readListBegin();
                        const size_44: number = metadata_44.size;
                        for (let i_44: number = 0; i_44 < size_44; i_44++) {
                            const value_309: string = input.readString();
                            value_308.push(value_309);
                        }
                        input.readListEnd();
                        _args.ccEmailAddresses = value_308;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_310: string = input.readString();
                        _args.subject = value_310;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_311: Int64 = input.readI64();
                        _args.timestampSec = value_311;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_312: string = input.readString();
                        _args.messageSnippet = value_312;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_313: string = input.readString();
                        _args.gmailDeepLink = value_313;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_314: string = input.readString();
                        _args.appleMailDeepLink = value_314;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_315: Array<EmailHeader> = new Array<EmailHeader>();
                        const metadata_45: thrift.TList = input.readListBegin();
                        const size_45: number = metadata_45.size;
                        for (let i_45: number = 0; i_45 < size_45; i_45++) {
                            const value_316: EmailHeader = input.readI32();
                            value_315.push(value_316);
                        }
                        input.readListEnd();
                        _args.displayHeaders = value_315;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppGmailMessage(_args);
    }
}
export enum TAppBTColocationProvenanceType {
    UNDEFINED = 0,
    IOS = 1,
    ANDROID = 2,
    WEB_CLIENT_MOBILE = 3,
    WEB_CLIENT_DESKTOP = 4
}
export enum TAppGNSEventType {
    LOST = 0,
    FOUND = 1
}
export enum TAppLocationEventType {
    UNDEFINED = 0,
    VISIT_ENTER = 1,
    VISIT_EXIT = 2,
    APP_OPEN = 3,
    NEARBY_OPEN = 4,
    NOTIFICATION_OPEN = 5,
    BACKGROUND_FETCH = 6
}
export enum TAppRawLocationProvenanceType {
    UNDEFINED = 0,
    IOS = 1,
    ANDROID = 2,
    WEB_CLIENT_MOBILE = 3,
    WEB_CLIENT_DESKTOP = 4
}
export interface ITAppNearbyUserDataArgs {
    userId?: string;
    name?: PContact.TAppName;
    photoUrl?: string;
    nearbyTimestamp?: number | Int64;
    contactId?: string;
}
export class TAppNearbyUserData {
    public userId?: string;
    public name?: PContact.TAppName;
    public photoUrl?: string;
    public nearbyTimestamp?: Int64;
    public contactId?: string;
    constructor(args?: ITAppNearbyUserDataArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        if (args != null && args.name != null) {
            this.name = args.name;
        }
        if (args != null && args.photoUrl != null) {
            this.photoUrl = args.photoUrl;
        }
        if (args != null && args.nearbyTimestamp != null) {
            if (typeof args.nearbyTimestamp === "number") {
                this.nearbyTimestamp = new Int64(args.nearbyTimestamp);
            }
            else {
                this.nearbyTimestamp = args.nearbyTimestamp;
            }
        }
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppNearbyUserData");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.name != null) {
            output.writeFieldBegin("name", thrift.Thrift.Type.STRUCT, 2);
            this.name.write(output);
            output.writeFieldEnd();
        }
        if (this.photoUrl != null) {
            output.writeFieldBegin("photoUrl", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.photoUrl);
            output.writeFieldEnd();
        }
        if (this.nearbyTimestamp != null) {
            output.writeFieldBegin("nearbyTimestamp", thrift.Thrift.Type.I64, 4);
            output.writeI64(this.nearbyTimestamp);
            output.writeFieldEnd();
        }
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppNearbyUserData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_317: string = input.readString();
                        _args.userId = value_317;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_318: PContact.TAppName = PContact.TAppName.read(input);
                        _args.name = value_318;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_319: string = input.readString();
                        _args.photoUrl = value_319;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_320: Int64 = input.readI64();
                        _args.nearbyTimestamp = value_320;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_321: string = input.readString();
                        _args.contactId = value_321;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppNearbyUserData(_args);
    }
}
export interface ITAppBTColocationDataArgs {
    ownerUserId?: string;
    connectedUserId?: string;
    connectedTimestamp?: number | Int64;
    disconnectedTimestamp?: number | Int64;
    ownerDeviceId?: string;
    ownerProvenance?: TAppBTColocationProvenanceType;
}
export class TAppBTColocationData {
    public ownerUserId?: string;
    public connectedUserId?: string;
    public connectedTimestamp?: Int64;
    public disconnectedTimestamp?: Int64;
    public ownerDeviceId?: string;
    public ownerProvenance?: TAppBTColocationProvenanceType;
    constructor(args?: ITAppBTColocationDataArgs) {
        if (args != null && args.ownerUserId != null) {
            this.ownerUserId = args.ownerUserId;
        }
        if (args != null && args.connectedUserId != null) {
            this.connectedUserId = args.connectedUserId;
        }
        if (args != null && args.connectedTimestamp != null) {
            if (typeof args.connectedTimestamp === "number") {
                this.connectedTimestamp = new Int64(args.connectedTimestamp);
            }
            else {
                this.connectedTimestamp = args.connectedTimestamp;
            }
        }
        if (args != null && args.disconnectedTimestamp != null) {
            if (typeof args.disconnectedTimestamp === "number") {
                this.disconnectedTimestamp = new Int64(args.disconnectedTimestamp);
            }
            else {
                this.disconnectedTimestamp = args.disconnectedTimestamp;
            }
        }
        if (args != null && args.ownerDeviceId != null) {
            this.ownerDeviceId = args.ownerDeviceId;
        }
        if (args != null && args.ownerProvenance != null) {
            this.ownerProvenance = args.ownerProvenance;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppBTColocationData");
        if (this.ownerUserId != null) {
            output.writeFieldBegin("ownerUserId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.ownerUserId);
            output.writeFieldEnd();
        }
        if (this.connectedUserId != null) {
            output.writeFieldBegin("connectedUserId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.connectedUserId);
            output.writeFieldEnd();
        }
        if (this.connectedTimestamp != null) {
            output.writeFieldBegin("connectedTimestamp", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.connectedTimestamp);
            output.writeFieldEnd();
        }
        if (this.disconnectedTimestamp != null) {
            output.writeFieldBegin("disconnectedTimestamp", thrift.Thrift.Type.I64, 4);
            output.writeI64(this.disconnectedTimestamp);
            output.writeFieldEnd();
        }
        if (this.ownerDeviceId != null) {
            output.writeFieldBegin("ownerDeviceId", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.ownerDeviceId);
            output.writeFieldEnd();
        }
        if (this.ownerProvenance != null) {
            output.writeFieldBegin("ownerProvenance", thrift.Thrift.Type.I32, 6);
            output.writeI32(this.ownerProvenance);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppBTColocationData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_322: string = input.readString();
                        _args.ownerUserId = value_322;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_323: string = input.readString();
                        _args.connectedUserId = value_323;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_324: Int64 = input.readI64();
                        _args.connectedTimestamp = value_324;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_325: Int64 = input.readI64();
                        _args.disconnectedTimestamp = value_325;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_326: string = input.readString();
                        _args.ownerDeviceId = value_326;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_327: TAppBTColocationProvenanceType = input.readI32();
                        _args.ownerProvenance = value_327;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppBTColocationData(_args);
    }
}
export interface ITAppGNSEventArgs {
    timestamp?: number | Int64;
    event?: TAppGNSEventType;
}
export class TAppGNSEvent {
    public timestamp?: Int64;
    public event?: TAppGNSEventType;
    constructor(args?: ITAppGNSEventArgs) {
        if (args != null && args.timestamp != null) {
            if (typeof args.timestamp === "number") {
                this.timestamp = new Int64(args.timestamp);
            }
            else {
                this.timestamp = args.timestamp;
            }
        }
        if (args != null && args.event != null) {
            this.event = args.event;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppGNSEvent");
        if (this.timestamp != null) {
            output.writeFieldBegin("timestamp", thrift.Thrift.Type.I64, 1);
            output.writeI64(this.timestamp);
            output.writeFieldEnd();
        }
        if (this.event != null) {
            output.writeFieldBegin("event", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.event);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppGNSEvent {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_328: Int64 = input.readI64();
                        _args.timestamp = value_328;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_329: TAppGNSEventType = input.readI32();
                        _args.event = value_329;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppGNSEvent(_args);
    }
}
export interface ITAppCoordinate2DArgs {
    lon?: number;
    lat?: number;
}
export class TAppCoordinate2D {
    public lon?: number;
    public lat?: number;
    constructor(args?: ITAppCoordinate2DArgs) {
        if (args != null && args.lon != null) {
            this.lon = args.lon;
        }
        if (args != null && args.lat != null) {
            this.lat = args.lat;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppCoordinate2D");
        if (this.lon != null) {
            output.writeFieldBegin("lon", thrift.Thrift.Type.DOUBLE, 1);
            output.writeDouble(this.lon);
            output.writeFieldEnd();
        }
        if (this.lat != null) {
            output.writeFieldBegin("lat", thrift.Thrift.Type.DOUBLE, 2);
            output.writeDouble(this.lat);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppCoordinate2D {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_330: number = input.readDouble();
                        _args.lon = value_330;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_331: number = input.readDouble();
                        _args.lat = value_331;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppCoordinate2D(_args);
    }
}
export interface ITAppLocationArgs {
    userId?: string;
    coordinate?: TAppCoordinate2D;
    altitude?: number;
    timestamp?: number;
    arrivalDate?: number;
    departureDate?: number;
    eventType?: TAppLocationEventType;
}
export class TAppLocation {
    public userId?: string;
    public coordinate?: TAppCoordinate2D;
    public altitude?: number;
    public timestamp?: number;
    public arrivalDate?: number;
    public departureDate?: number;
    public eventType?: TAppLocationEventType;
    constructor(args?: ITAppLocationArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        if (args != null && args.coordinate != null) {
            this.coordinate = args.coordinate;
        }
        if (args != null && args.altitude != null) {
            this.altitude = args.altitude;
        }
        if (args != null && args.timestamp != null) {
            this.timestamp = args.timestamp;
        }
        if (args != null && args.arrivalDate != null) {
            this.arrivalDate = args.arrivalDate;
        }
        if (args != null && args.departureDate != null) {
            this.departureDate = args.departureDate;
        }
        if (args != null && args.eventType != null) {
            this.eventType = args.eventType;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppLocation");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.coordinate != null) {
            output.writeFieldBegin("coordinate", thrift.Thrift.Type.STRUCT, 2);
            this.coordinate.write(output);
            output.writeFieldEnd();
        }
        if (this.altitude != null) {
            output.writeFieldBegin("altitude", thrift.Thrift.Type.DOUBLE, 3);
            output.writeDouble(this.altitude);
            output.writeFieldEnd();
        }
        if (this.timestamp != null) {
            output.writeFieldBegin("timestamp", thrift.Thrift.Type.DOUBLE, 4);
            output.writeDouble(this.timestamp);
            output.writeFieldEnd();
        }
        if (this.arrivalDate != null) {
            output.writeFieldBegin("arrivalDate", thrift.Thrift.Type.DOUBLE, 5);
            output.writeDouble(this.arrivalDate);
            output.writeFieldEnd();
        }
        if (this.departureDate != null) {
            output.writeFieldBegin("departureDate", thrift.Thrift.Type.DOUBLE, 6);
            output.writeDouble(this.departureDate);
            output.writeFieldEnd();
        }
        if (this.eventType != null) {
            output.writeFieldBegin("eventType", thrift.Thrift.Type.I32, 7);
            output.writeI32(this.eventType);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppLocation {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_332: string = input.readString();
                        _args.userId = value_332;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_333: TAppCoordinate2D = TAppCoordinate2D.read(input);
                        _args.coordinate = value_333;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_334: number = input.readDouble();
                        _args.altitude = value_334;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_335: number = input.readDouble();
                        _args.timestamp = value_335;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_336: number = input.readDouble();
                        _args.arrivalDate = value_336;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_337: number = input.readDouble();
                        _args.departureDate = value_337;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_338: TAppLocationEventType = input.readI32();
                        _args.eventType = value_338;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppLocation(_args);
    }
}
export interface ITAppRawLocationArgs {
    userId?: string;
    deviceId?: string;
    provenance?: TAppRawLocationProvenanceType;
    coordinate?: TAppCoordinate2D;
    horizontalAccuracy?: number;
    altitude?: number;
    verticalAccuracy?: number;
    speed?: number;
    speedAccuracy?: number;
    bearing?: number;
    bearingAccuracy?: number;
    timestamp?: number;
    batteryLevel?: number;
    ipAddress?: string;
}
export class TAppRawLocation {
    public userId?: string;
    public deviceId?: string;
    public provenance?: TAppRawLocationProvenanceType;
    public coordinate?: TAppCoordinate2D;
    public horizontalAccuracy?: number;
    public altitude?: number;
    public verticalAccuracy?: number;
    public speed?: number;
    public speedAccuracy?: number;
    public bearing?: number;
    public bearingAccuracy?: number;
    public timestamp?: number;
    public batteryLevel?: number;
    public ipAddress?: string;
    constructor(args?: ITAppRawLocationArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        if (args != null && args.deviceId != null) {
            this.deviceId = args.deviceId;
        }
        if (args != null && args.provenance != null) {
            this.provenance = args.provenance;
        }
        if (args != null && args.coordinate != null) {
            this.coordinate = args.coordinate;
        }
        if (args != null && args.horizontalAccuracy != null) {
            this.horizontalAccuracy = args.horizontalAccuracy;
        }
        if (args != null && args.altitude != null) {
            this.altitude = args.altitude;
        }
        if (args != null && args.verticalAccuracy != null) {
            this.verticalAccuracy = args.verticalAccuracy;
        }
        if (args != null && args.speed != null) {
            this.speed = args.speed;
        }
        if (args != null && args.speedAccuracy != null) {
            this.speedAccuracy = args.speedAccuracy;
        }
        if (args != null && args.bearing != null) {
            this.bearing = args.bearing;
        }
        if (args != null && args.bearingAccuracy != null) {
            this.bearingAccuracy = args.bearingAccuracy;
        }
        if (args != null && args.timestamp != null) {
            this.timestamp = args.timestamp;
        }
        if (args != null && args.batteryLevel != null) {
            this.batteryLevel = args.batteryLevel;
        }
        if (args != null && args.ipAddress != null) {
            this.ipAddress = args.ipAddress;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppRawLocation");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.deviceId != null) {
            output.writeFieldBegin("deviceId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.deviceId);
            output.writeFieldEnd();
        }
        if (this.provenance != null) {
            output.writeFieldBegin("provenance", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.provenance);
            output.writeFieldEnd();
        }
        if (this.coordinate != null) {
            output.writeFieldBegin("coordinate", thrift.Thrift.Type.STRUCT, 4);
            this.coordinate.write(output);
            output.writeFieldEnd();
        }
        if (this.horizontalAccuracy != null) {
            output.writeFieldBegin("horizontalAccuracy", thrift.Thrift.Type.DOUBLE, 5);
            output.writeDouble(this.horizontalAccuracy);
            output.writeFieldEnd();
        }
        if (this.altitude != null) {
            output.writeFieldBegin("altitude", thrift.Thrift.Type.DOUBLE, 6);
            output.writeDouble(this.altitude);
            output.writeFieldEnd();
        }
        if (this.verticalAccuracy != null) {
            output.writeFieldBegin("verticalAccuracy", thrift.Thrift.Type.DOUBLE, 7);
            output.writeDouble(this.verticalAccuracy);
            output.writeFieldEnd();
        }
        if (this.speed != null) {
            output.writeFieldBegin("speed", thrift.Thrift.Type.DOUBLE, 8);
            output.writeDouble(this.speed);
            output.writeFieldEnd();
        }
        if (this.speedAccuracy != null) {
            output.writeFieldBegin("speedAccuracy", thrift.Thrift.Type.DOUBLE, 9);
            output.writeDouble(this.speedAccuracy);
            output.writeFieldEnd();
        }
        if (this.bearing != null) {
            output.writeFieldBegin("bearing", thrift.Thrift.Type.DOUBLE, 10);
            output.writeDouble(this.bearing);
            output.writeFieldEnd();
        }
        if (this.bearingAccuracy != null) {
            output.writeFieldBegin("bearingAccuracy", thrift.Thrift.Type.DOUBLE, 11);
            output.writeDouble(this.bearingAccuracy);
            output.writeFieldEnd();
        }
        if (this.timestamp != null) {
            output.writeFieldBegin("timestamp", thrift.Thrift.Type.DOUBLE, 12);
            output.writeDouble(this.timestamp);
            output.writeFieldEnd();
        }
        if (this.batteryLevel != null) {
            output.writeFieldBegin("batteryLevel", thrift.Thrift.Type.DOUBLE, 13);
            output.writeDouble(this.batteryLevel);
            output.writeFieldEnd();
        }
        if (this.ipAddress != null) {
            output.writeFieldBegin("ipAddress", thrift.Thrift.Type.STRING, 14);
            output.writeString(this.ipAddress);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppRawLocation {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_339: string = input.readString();
                        _args.userId = value_339;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_340: string = input.readString();
                        _args.deviceId = value_340;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_341: TAppRawLocationProvenanceType = input.readI32();
                        _args.provenance = value_341;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_342: TAppCoordinate2D = TAppCoordinate2D.read(input);
                        _args.coordinate = value_342;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_343: number = input.readDouble();
                        _args.horizontalAccuracy = value_343;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_344: number = input.readDouble();
                        _args.altitude = value_344;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_345: number = input.readDouble();
                        _args.verticalAccuracy = value_345;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_346: number = input.readDouble();
                        _args.speed = value_346;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_347: number = input.readDouble();
                        _args.speedAccuracy = value_347;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_348: number = input.readDouble();
                        _args.bearing = value_348;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_349: number = input.readDouble();
                        _args.bearingAccuracy = value_349;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_350: number = input.readDouble();
                        _args.timestamp = value_350;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 13:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_351: number = input.readDouble();
                        _args.batteryLevel = value_351;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 14:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_352: string = input.readString();
                        _args.ipAddress = value_352;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppRawLocation(_args);
    }
}
export interface ITAppLocationSuggestionArgs {
    placeId?: string;
    locationDescription?: string;
    locationTypes?: Array<string>;
    reference?: string;
}
export class TAppLocationSuggestion {
    public placeId?: string;
    public locationDescription?: string;
    public locationTypes?: Array<string>;
    public reference?: string;
    constructor(args?: ITAppLocationSuggestionArgs) {
        if (args != null && args.placeId != null) {
            this.placeId = args.placeId;
        }
        if (args != null && args.locationDescription != null) {
            this.locationDescription = args.locationDescription;
        }
        if (args != null && args.locationTypes != null) {
            this.locationTypes = args.locationTypes;
        }
        if (args != null && args.reference != null) {
            this.reference = args.reference;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppLocationSuggestion");
        if (this.placeId != null) {
            output.writeFieldBegin("placeId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.placeId);
            output.writeFieldEnd();
        }
        if (this.locationDescription != null) {
            output.writeFieldBegin("locationDescription", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.locationDescription);
            output.writeFieldEnd();
        }
        if (this.locationTypes != null) {
            output.writeFieldBegin("locationTypes", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.locationTypes.length);
            this.locationTypes.forEach((value_353: string): void => {
                output.writeString(value_353);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.reference != null) {
            output.writeFieldBegin("reference", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.reference);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppLocationSuggestion {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_354: string = input.readString();
                        _args.placeId = value_354;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_355: string = input.readString();
                        _args.locationDescription = value_355;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_356: Array<string> = new Array<string>();
                        const metadata_46: thrift.TList = input.readListBegin();
                        const size_46: number = metadata_46.size;
                        for (let i_46: number = 0; i_46 < size_46; i_46++) {
                            const value_357: string = input.readString();
                            value_356.push(value_357);
                        }
                        input.readListEnd();
                        _args.locationTypes = value_356;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_358: string = input.readString();
                        _args.reference = value_358;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppLocationSuggestion(_args);
    }
}
export interface ITAppTweetArgs {
    twitterHandle?: string;
    timestampSec?: number | Int64;
    tweetText?: string;
    deepLink?: string;
    tweetUrl?: string;
}
export class TAppTweet {
    public twitterHandle?: string;
    public timestampSec?: Int64;
    public tweetText?: string;
    public deepLink?: string;
    public tweetUrl?: string;
    constructor(args?: ITAppTweetArgs) {
        if (args != null && args.twitterHandle != null) {
            this.twitterHandle = args.twitterHandle;
        }
        if (args != null && args.timestampSec != null) {
            if (typeof args.timestampSec === "number") {
                this.timestampSec = new Int64(args.timestampSec);
            }
            else {
                this.timestampSec = args.timestampSec;
            }
        }
        if (args != null && args.tweetText != null) {
            this.tweetText = args.tweetText;
        }
        if (args != null && args.deepLink != null) {
            this.deepLink = args.deepLink;
        }
        if (args != null && args.tweetUrl != null) {
            this.tweetUrl = args.tweetUrl;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppTweet");
        if (this.twitterHandle != null) {
            output.writeFieldBegin("twitterHandle", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.twitterHandle);
            output.writeFieldEnd();
        }
        if (this.timestampSec != null) {
            output.writeFieldBegin("timestampSec", thrift.Thrift.Type.I64, 2);
            output.writeI64(this.timestampSec);
            output.writeFieldEnd();
        }
        if (this.tweetText != null) {
            output.writeFieldBegin("tweetText", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.tweetText);
            output.writeFieldEnd();
        }
        if (this.deepLink != null) {
            output.writeFieldBegin("deepLink", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.deepLink);
            output.writeFieldEnd();
        }
        if (this.tweetUrl != null) {
            output.writeFieldBegin("tweetUrl", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.tweetUrl);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppTweet {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_359: string = input.readString();
                        _args.twitterHandle = value_359;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_360: Int64 = input.readI64();
                        _args.timestampSec = value_360;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_361: string = input.readString();
                        _args.tweetText = value_361;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_362: string = input.readString();
                        _args.deepLink = value_362;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_363: string = input.readString();
                        _args.tweetUrl = value_363;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppTweet(_args);
    }
}
